<template>
    <div>
      <div class="mapdiv" v-if="tk&&mkList.length>0">
          <pl-lazy>
              <main-map
              ref="mainmap"
              :lyrdata="lyrdata"
              :mapCtrlTools="mapCtrlTools4Use"
              :mapParams="mapParams"
              :showSearchBar="false"
              v-if="!fenpingOpen"
              >
              </main-map>
              <splite-map
              ref="mainmap"
              :lyrdata="lyrdata"
              :mapCtrlTools="mapCtrlTools4Use"
              :mapParams="mapParams"
              :showSearchBar="false"
              v-if="fenpingOpen"
              >
              </splite-map>

          </pl-lazy>
      </div>
      <div class="bak" v-if="showBak"></div>
      <!--关闭标签-->
      <img
          v-show="juanlianOpen||fenpingOpen"
          style="position: absolute; top: 60px;right:30px;z-index:1; cursor: pointer"
          src="~@/assets/RSsserviceManage/套件使用逻辑素材/公共内容/退出分屏或卷帘(默认).png"
          height="40"
          width="40"
          title="退出"
          @click="juanlianOpen?closeJL():fenpingOpen=false"
      />
      <!-- 假卷帘 -->
      <div class="juanlianContent" v-show="fakeJuanLianOpen">
          <div style="position: fixed;width: 25vw;height: 44px;top: 62px;left: 200px;z-index: 1002; background-color: rgba(0,0,0,0.5);border:none;border-radius: 8px;display: flex;align-items: center;justify-content: center;color:#FFFFFF;">{{ leftCompareName }}</div>
          <div class="fakeMaskLock"><img src="~@/assets/RSsserviceManage/套件使用逻辑素材/GIS工具栏/带锁卷帘(假卷帘).png"></div>
          <div class="fakeMask" style="background-color: black;height: 100vh;width: 50vw;position: absolute;left: 50%;border-left: 4px solid white;">
            <span style="color: white;position: absolute;top: 62px;left: calc(50% - 49px);line-height: 40px;">请选择对比图源</span>
            <img style="top: 60px;right: 37px;cursor: pointer;width: 40px;height: 40px;position: absolute;" src="~@/assets/RSsserviceManage/套件使用逻辑素材/GIS工具栏/退出.png" title="退出" @click="juanlianOpen?closeJL():fenpingOpen=false">
            <div class="panel">
              <v-radio-group
                  v-model="selectedCompareImg"
                  row
                  style="width:500px;padding: 20px 0 0 50px;"
                  column
                >
                <template v-for="(item, index) in compareImgs">
                  <v-radio :key="'compareImgs'+index"
                      :label="item.label"
                      color="#ffffff"
                      :value="item.value"
                  ></v-radio>
                </template>
              </v-radio-group>
              <div class="divider"><v-divider/><span>以下图源可能无法有效参与对比</span><v-divider/></div>
              <v-radio-group
                  disabled
                  row
                  style="width:500px;padding: 0 0 0 50px;"
                  column
                >
                <template v-for="(item, index) in compareImgsDisabled">
                  <v-radio :key="'compareImgsDisabled'+index"
                      :label="item.label"
                      color="#777777"
                      :value="item.value"
                  ></v-radio>
                </template>
              </v-radio-group>
            </div>
          </div>

      </div>
      <!-- 卷帘 -->
      <div class="juanlianContent" v-show="juanlianOpen&&!fakeJuanLianOpen">
          <a-select id="juanlianList1" v-model="leftCompareName" @change='changeMaps("left")' placeholder="请选择影像"
          style="position: fixed;width: 25vw;height: 30px;top: 62px;left: 200px;z-index: 1002; background-color: rgba(0,0,0,0.5);border:none;">
          <a-select-option v-for="item in dataList" :key="item.value" :value="item.value">{{ item.label }}
          </a-select-option>
          </a-select>
          <a-select id="juanlianList2" v-model="rightCompareName" @change='changeMaps("right")' placeholder="请选择影像"
          style="position: fixed;width: 25vw;height: 30px;top: 62px;right:200px;z-index: 1002; background-color: rgba(0,0,0,0.5);border:none;">
          <a-select-option v-for="item in dataList" :key="item.value" :value="item.value">{{ item.label }}
          </a-select-option>
          </a-select>
          <!-- <div class="juanlianClose" @click="endCompare()">
          </div> -->
      </div>
      <div class="juanlianContent" v-show="fenpingOpen">
          <a-select id="juanlianList1" v-model="fenpingName[0]" @change='fenpingChangeLayer' placeholder="请选择影像"
          style="position: fixed;width: 25vw;height: 30px;top: 62px;left: 200px;z-index: 1002; background-color: rgba(0,0,0,0.5);border:none;">
          <a-select-option v-for="item in dataList" :key="item.value" :value="item.value">{{ item.label }}
          </a-select-option>
          </a-select>
          <a-select id="juanlianList2" v-model="fenpingName[1]" @change='fenpingChangeLayer' placeholder="请选择影像"
          style="position: fixed;width: 25vw;height: 30px;top: 62px;right:200px;z-index: 1002; background-color: rgba(0,0,0,0.5);border:none;">
          <a-select-option v-for="item in dataList" :key="item.value" :value="item.value">{{ item.label }}
          </a-select-option>
          </a-select>
          <a-select id="juanlianList3" v-model="fenpingName[2]" @change='fenpingChangeLayer' placeholder="请选择影像"
          style="position: fixed;width: 25vw;height: 30px;top: calc(62px + 50vh);left: 200px;z-index: 1002; background-color: rgba(0,0,0,0.5);border:none;">
          <a-select-option v-for="item in dataList" :key="item.value" :value="item.value">{{ item.label }}
          </a-select-option>
          </a-select>
          <a-select id="juanlianList4" v-model="fenpingName[3]" @change='fenpingChangeLayer' placeholder="请选择影像"
          style="position: fixed;width: 25vw;height: 30px;top: calc(62px + 50vh);right:200px;z-index: 1002; background-color: rgba(0,0,0,0.5);border:none;">
          <a-select-option v-for="item in dataList" :key="item.value" :value="item.value">{{ item.label }}
          </a-select-option>
          </a-select>
          <!-- <div class="juanlianClose" @click="endCompare()">
          </div> -->
      </div>

      <!-- 图源列表和顶bar -->
      <div class="laboratoryLogo" v-show="!(juanlianOpen||fenpingOpen)">
        <div class="mark"></div>
        <!-- <div class="recordBtn" @click="showRecordPanel=true;getDateData1(repositoryId, year, month1 + 1) " title="流量监控"></div> -->
        <div :class="showMyLayersAndVectorPanel==true ? 'tabsNavi' : 'tabsNavi-s'">
            <SearchBar></SearchBar>
            <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/新手引导.png" alt="" style="position: absolute;right:100px;top:21px;cursor:pointer;" title="新手引导" @click="newGuide=1">

           <div class="tabsNaviClose" @click="$router.push('/MyRSservice')">关闭</div>
        </div>
        <div class="layersAndVectorsPanel" v-if="showMyLayersAndVectorPanel&&!showTipPanel">
          <div class="tabs">
            <div :class="`tab lefttab ${layersAndVectorsTabs[0]}`" @click="showMyLayers">我的图源</div>
            <div :class="`tab righttab ${layersAndVectorsTabs[1]}`" @click="showMyVectors">我的矢量</div>
          </div>
          <div class="tabPanels">
            <div v-if="myLayersPanelShow" class="layersPanel">
                <div style="width: 10px;height: 25px;"></div>
                <!-- 购买区县图展示 -->
                <div v-for="(item, index) in countyQuarterList" :key="'county'+index">
                  <div :class="item.choose==true ? 'tabPanelsBlock1-s' : 'tabPanelsBlock1'">
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/单选未选中.png" alt="" class="tabBlock1Select" v-if="!item.choose" @click="countySelect(item)">
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/单选选中.png" alt="" class="tabBlock1Select" v-if="item.choose">
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 41px;top: 5px;">
                    <img src="../assets/LayersThumb/2022年度全国高质量一张图.png" alt="" style="position:absolute;left: 46px;top: 10px;width: 32px;height: 32px;">
                    <div class="tabBlock1Text1" :title="item.name">{{ item.name }}</div>
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/分辨率icon.png" alt="" style="position:absolute;left: 96px;top:34px;">
                    <div class="tabBlock1Text2">{{ item.resolution }}m</div>
                  </div>
                </div>
                <!-- 购买标准版套件展示 -->
                <!-- 购买企业版展示 -->
                <div v-for="(item, index) in quarterList" :key="index">
                  <div :class="enterprise4Quarter[index]==true ? 'tabPanelsBlock1-s' : 'tabPanelsBlock1'">
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/文件夹收回.png" alt="" class="tabBlock1Select" style="left: 15px;top: 16px;" v-if="!enterprise4Quarter[index]" @click="openEnterprise4Quarter(1,index,item)">
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/文件夹打开.png" alt="" class="tabBlock1Select" style="top: 20px;" v-if="enterprise4Quarter[index]" @click="openEnterprise4Quarter(0,index,item)">
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 41px;top: 5px;">
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/橙色文件夹默认.png" alt="" style="position:absolute;left: 52px;top: 18px;" v-if="!enterprise4Quarter[index]">
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/橙色文件夹打开.png" alt="" style="position:absolute;left: 49px;top: 18px;" v-if="enterprise4Quarter[index]">
                    <div class="tabBlock1Text1">{{ item.name }}</div>
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/分辨率icon.png" alt="" style="position:absolute;left: 96px;top:34px;">
                    <div class="tabBlock1Text2">{{ item.resolution }}m</div>
                  </div>
                  <div v-for="(item1, index1) in projectList[index]" :key="'pro'+index1">
                    <div class="tabPanelsBlock1-s" v-if="enterprise4Quarter[index]&&haveProject[index]&&interfaceSuccess">
                      <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/单选未选中.png" alt="" class="tabBlock1Select" v-if="!enterpriseProject[index][index1]" @click="openEnterpriseProject(item,index,index1,1)" style="left:35px">
                      <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/单选选中.png" alt="" class="tabBlock1Select" v-if="enterpriseProject[index][index1]"  style="left:35px">
                      <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 67px;top: 5px;">
                      <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/项目icon.png" alt="" style="position:absolute;left: 77px;top: 16px;">
                      <!-- <div class="tabBlock1Text1" style="left:118px">{{ item1.name }}</div> -->
                      <div class="tabBlock1Text1" style="left:118px">{{ item1.name }}<span v-if="item1.end_time<getTodayTime()" style="color:red;">【已过期】</span><span v-if="item1.start_time>getTodayTime()" style="color:red;">【尚未到期】</span></div>

                      <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/创建日期icon.png" alt="" title="起始时间" style="position:absolute;left: 118px;top:34px;">
                      <div class="tabBlock1Text2" style="left:137px;width: 150px;">{{ item1.start_time.split(' ')[0] }}</div>
                      <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/截至时间.png" alt="" title="截至时间" style="position:absolute;left: 228px;top:34px;width: 14px;">
                      <div class="tabBlock1Text2" style="left:247px;width: 150px;">{{ item1.end_time.split(' ')[0] }}</div>
                    </div>
                  </div>
                  <div class="tabPanelsBlock1-s" style="height: 170px;" v-if="enterprise4Quarter[index]&&!haveProject[index]&&interfaceSuccess">
                    <div class="tabBlock1Text3">您需要创建项目才能查看定制区域内的影像</div>
                    <div class="tabBlock1Button1" @click="$router.push({path: 'userCenter', query: {'type': 1}})">立即创建项目</div>
                  </div>
                  <div class="tabPanelsBlock1-s" style="height: 140px;" v-if="enterprise4Quarter[index]&&!interfaceSuccess">
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/加载中.png" alt="" style="position: absolute;top:25px;width: 50px;left: 190px;">
                    <div class="tabBlock1Text3" style="top: 90px;left: 165px;">加载中，请稍后...</div>
                  </div>
                </div>
                <!-- 免费一张图展示 -->
                <div v-for="(item, index) in countryList" :key="'country'+index">
                  <div :class="item.choose==true ? 'tabPanelsBlock1-s' : 'tabPanelsBlock1'">
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/单选未选中.png" alt="" class="tabBlock1Select" v-if="!item.choose" @click="chinaFree(item)">
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/单选选中.png" alt="" class="tabBlock1Select" v-if="item.choose" >
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 41px;top: 5px;">
                    <img src="../assets/LayersThumb/2022年度全国高质量一张图.png" alt="" style="position:absolute;left: 46px;top: 10px;width: 32px;height: 32px;">
                    <div class="tabBlock1Text1">{{ item.name }}</div>
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/分辨率icon.png" alt="" style="position:absolute;left: 96px;top:34px;">
                    <div class="tabBlock1Text2">{{ item.resolution }}m</div>
                    <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/卷帘对比.png" alt="" style="position:absolute;right:15px;top:6px;"  @click="juanlian(item,countryList)" title="卷帘对比">
                  </div>
                </div>
                <!-- 2022各地区图像文件夹 -->
                <div>
                  <div v-for="(item, index) in county2022FileList" :key="'file'+index">
                    <div :class="county2022[index]==true ? 'tabPanelsBlock1-s' : 'tabPanelsBlock1'">
                        <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/文件夹收回.png" alt="" class="tabBlock1Select" style="left: 15px;top: 16px;" v-if="county2022[index]==false" @click="openCounty2022(index,1,item)">
                        <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/文件夹打开.png" alt="" class="tabBlock1Select" style="top: 20px;" v-if="county2022[index]==true" @click="openCounty2022(index,0,item)">
                        <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 41px;top: 5px;">
                        <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/蓝色文件夹默认.png" alt="" style="position:absolute;left: 52px;top: 18px;" v-if="!county2022[index]">
                        <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/蓝色文件夹打开.png" alt="" style="position:absolute;left: 49px;top: 18px;" v-if="county2022[index]">
                        <div class="tabBlock1Text1" style="top: 15px;">{{ item.name }}</div>
                        <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/分屏对比.png" alt="" style="position:absolute;right: 15px;;top:10px;" title="分屏对比" @click="fenping(item)">
                    </div>
                    <div v-for="(item1, index1) in item.mkList" :key="'mk'+index1">
                        <div :class="county2022[index]==true ? 'tabPanelsBlock1-s' : 'tabPanelsBlock1'" v-if="county2022[index]==true">
                          <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/单选未选中.png" alt="" class="tabBlock1Select" v-if="county20224Quarter[index][index1]==false" @click="openCounty20224Quarter(index,index1,item1,1)" style="left:35px">
                          <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/单选选中.png" alt="" class="tabBlock1Select" v-if="county20224Quarter[index][index1]==true" @click="openCounty20224Quarter(index,index1,item1,0)" style="left:35px">
                          <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/边框.png" alt="" style="position:absolute;left: 67px;top: 5px;">
                          <img :src="require(`../assets/LayersThumb/2022年度全国高质量一张图.png`)" alt="" style="position:absolute;left: 72px;top: 10px;width: 32px;height: 32px;">
                          <div class="tabBlock1Text1" style="left:118px">{{ item1.name }}</div>
                          <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/分辨率icon.png" alt="" style="position:absolute;left: 118px;top:34px;">
                          <div class="tabBlock1Text2" style="left:137px">0.75 m</div>
                          <img src="../assets/RSsserviceManage/套件使用逻辑素材/图源与矢量管理/卷帘对比.png" alt="" style="position:absolute;right:15px;top:6px;"  @click="juanlian(item1,item.mkList)" title="卷帘对比">

                        </div>
                    </div>
                  </div>
                </div>
              <div @click="$router.push('/imageSegmentation')"  class="createImgSeparateCtn">
                <img src="../assets/rsTool/创建按钮.png" height="22" width="22" style="display: inline-block;margin-right: 5px;" />
                创建影像拆分
              </div>

            </div>
            <div v-else class="layersPanel">
              <!-- <div v-for="vec in tableData" :key="mk.name" class="vectorLi"> -->
                <a-checkbox-group v-model="checkBoxVectorObj.checkedList" name="checkboxgroup" @change="onVectorChangeOption" >
                  <!-- <perfect-scrollbar> -->

                    <div v-for="(vec,index) in tableData" :key="'table'+index" class="layersLi vectorLi">
                      <div>
                        <a-checkbox :value="vec.name"></a-checkbox>
                      </div>
                      <div class="thumbImg">
                        <img v-if="/Point/i.test(vec.shape_type)" src="../assets/Laboratory/点.png"/>
                        <img v-if="/Line/i.test(vec.shape_type)" src="../assets/Laboratory/线.png"/>
                        <img v-if="/Polygon/i.test(vec.shape_type)" src="../assets/Laboratory/面.png"/>
                      </div>
                      <div class="mkInfo">
                        <div>{{vec.name}}</div>
                        <div><img src="../assets/Laboratory/发布时间.png"/> {{ vec.create_time }}</div>
                      </div>

                    </div>
                  <!-- </perfect-scrollbar> -->

                </a-checkbox-group>
                <div @click="$router.push('/vectoryLibrary')"  class="createImgSeparateCtn" style="margin-bottom: 20px;">
                  <img src="../assets/rsTool/创建按钮.png" height="22" width="22" style="display: inline-block;margin-right: 5px;" />
                  创建矢量
                </div>
              <!-- </div> -->
            </div>

          </div>

          <div class="closePanel" @click="showMyLayersAndVectorPanel=false"></div>
        </div>
        <div class="closePanelImg" @click="showMyLayersAndVectorPanel=true"></div>

      </div>

      <!-- 流量统计弹窗 -->
      <div class="shadow" v-show="showRecordPanel">
        <div class="dialog">
          <img
            src="~@/assets/Laboratory/关闭弹窗.png"
            alt=""
            class="dialogImg"
            @click="showRecordPanel = false"
          />
          <div v-if="showCount==0">
            <div class="countTitle">调用次数监控</div>
            <div class="countText1">今日已使用次数：{{totalNumToday}}/{{ canUseCountToday}}</div>
            <div class="countWhite">
                <div class="greyImg" v-if="calendarHover"></div>
                <img src="~@/assets/Laboratory/日历.png" alt="" class="countIcon1" @mouseenter="calendarHover=true" @mouseleave="calendarHover = false" @click="calendarShow=true">
                <img :src="leftHover?require('../assets/Laboratory/左_hover.png'):require('../assets/Laboratory/左.png')" alt="" class="countIcon2" @mouseenter="leftHover=true" @mouseleave="leftHover = false" @click="changeDate(0)" v-if="canLeft">
                <!-- <img src="~@/assets/newHome/左箭头灰.png" alt="" class="countIcon2" v-if="!canLeft"> -->
                <img :src="rightHover?require('../assets/Laboratory/右_hover.png'):require('../assets/Laboratory/右.png')" alt="" class="countIcon2" style="left: 370px;" @mouseenter="rightHover=true" @mouseleave="rightHover = false" @click="changeDate(1)" v-if="canRight">
                <!-- <img src="~@/assets/newHome/右箭头灰.png" alt="" class="countIcon2" style="left: 370px;"  v-if="!canRight"> -->
                <div class="countText2">{{year}}年{{month}}月</div>
                <div class="countCalendar">
                    <div v-for="(item, index) in dayList" :key="index">
                        <div class="countCircle" :class="[index==0 ? 'countCirclespe1':'', index==7||index==16||index==25 ? 'countCirclespe2':'']"  @click="changeColor(index)" v-show="dateCanShow[index]">
                            <div class="countCircle1" :id="'countCircle' + index"></div>
                            <div class="countCircle2" :id="'countCircles' + index">{{index+1}}</div>
                        </div>
                    </div>
                </div>
                <div class="calendarDialog" v-if="calendarShow">
                    <img src="~@/assets/newHome/日历关闭.png" alt="" class="countIcon3" @click="calendarShow=false">
                    <div :class="year==2024 ? 'calendarYear-s' : 'calendarYear'" @click="changeYear(2024)">2024年</div>
                    <div :class="year==2025 ? 'calendarYear-s' : 'calendarYear'" style="left: 168px;" @click="changeYear(2025)">2025年</div>
                    <div :class="year==2026 ? 'calendarYear-s' : 'calendarYear'" style="left: 236px;" @click="changeYear(2026)">2026年</div>
                    <div class="calendarMonth">
                        <div v-for="(item, index) in monthList" :key="index">
                            <div  :class="month1==index ? 'calendarMonth1-s' : 'calendarMonth1'" @click="changeMonth(index)">{{index+1}}月</div>
                        </div>
                    </div>
                </div>
                <div class="totalStatistics">{{yearSelect}}年{{monthSelect+1}}月{{daySelect}}日总调用次数：<span style="color: #FFFFFF ;">{{ totalNum }}</span><br>
                    各图调用次数如右侧所示
                </div>
                <div class="calendarTip">提示:调用次数统计结果可能存在延迟</div>
                <div class="mkStatistics">
                    <div v-for="(item, index) in mkNumList" :key="index">
                        <div class="mkNum">
                            <div class="mkNumName">{{ mkNumList[index].name }}<span style="color: #1E81EB;">MK</span></div>
                            <div class="mkNumCount">{{ mkNumList[index].count }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
      </div>
      <div class="newGuideShadow" v-if="newGuide==1">
          <div class="newGuide1Text1">新手使用引导 (1/4)</div>
          <div class="newGuide1Block">
            <div class="newGuideBlock1">
              <div class="newGuide1Text2">在“我的图源”中您可以浏览体验版或企业版(需购买)套件中提供的全部影像数据，支持多期影像的卷帘对比和四季度影像的分屏对比</div>
              <div class="newGuide1Button1" @click="newGuide=0">跳过教程</div>
              <div class="newGuide1Button1" style="left: 203px;" @click="newGuide=2;myLayersPanelShow=false;layersAndVectorsTabs=['','active']">下一项</div>
            </div>
          </div>
      </div>
      <div class="newGuideShadow" v-if="newGuide==2">
          <div class="newGuide1Text1">新手使用引导 (2/4)</div>
          <div class="newGuide1Block">
            <div class="newGuideBlock1">
              <div class="newGuide1Text2">在“我的矢量”中可以浏览您的矢量库中的所有矢量，支持创建、下载、管理或删除矢量</div>
              <div class="newGuide1Button1" @click="newGuide=0">跳过教程</div>
              <div class="newGuide1Button1" style="left: 203px;" @click="newGuide=3">下一项</div>
            </div>
          </div>
      </div>
      <div v-if="newGuide==3">
        <div class="newGuideShadow31"></div>
        <div class="newGuideShadow32"></div>
        <div class="newGuideShadow33">
          <div class="newGuide1Text1" style="top: 20px;left: 131px;">新手使用引导 (3/4)</div>
          <div class="newGuide1Block" style="top: 60px;left: 30px;">
            <div class="newGuideBlock1">
              <div class="newGuide1Text2">支持文字/坐标点POI搜索</div>
              <div class="newGuide1Button1" @click="newGuide=0">跳过教程</div>
              <div class="newGuide1Button1" style="left: 203px;" @click="newGuide=4">下一项</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="newGuide==4">
        <div class="newGuideShadow41"></div>
        <div class="newGuideShadow42">
          <div class="newGuide4Text1">新手使用引导 (4/4)</div>
          <div class="newGuide4Block">
            <div class="newGuideBlock1">
              <div class="newGuide1Text2">绘制(标注)多边形、矩形、圆形、线矢量、行政区快选、上传矢量文件，测距离、测面积，路网标记开关，缩放按钮及缩放等级显示，快速指北</div>
              <div class="newGuide1Button1" @click="newGuide=0" style="left: 143px;">我知道啦</div>
            </div>
          </div>
        </div>
        <div class="newGuideShadow43"></div>
      </div>
      <!-- <div class="fenpingShadow" v-if="fenpingOpen">
        <div class="shadowContent11">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="fenpingOpen=false">
                <div class="shadowText11">用户提示</div>
                <div class="shadowText22">亲爱的用户，分屏对比功能暂未开放，敬请期待！</div>
                <div class="shadowButton22" @click="fenpingOpen=false">确认</div>
            </div>
      </div> -->
      <v-overlay :value="overlay">
        <span>正在处理，请稍后</span>
        <v-progress-circular indeterminate size="32"></v-progress-circular>
      </v-overlay>
    </div>
  </template>

  <script>

  // import FlowMonit from "./FlowMonit";
  import MainMap from '@/components/Maps/MainMap'
  import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
  import MapboxVectorLayer from 'ol/layer/MapboxVector';
  import { Vector,Tile } from 'ol/layer';
  import { XYZ } from 'ol/source'
  import { Polygon, LineString, MultiPolygon,MultiLineString,Point } from 'ol/geom'
  import Feature from 'ol/Feature';

  import Axios from 'axios'
  import coordtransform from 'coordtransform'
  import { fromLonLat,toLonLat,transform } from 'ol/proj'
  import {convertGPSToXY, convertXYToGPS, convertGPSToArray, convertArrayToGPS} from '../components/Maps/utils/convertGPSAndXY'
  import SearchBar from '@/components/Maps/utils/SearchBar.vue'
  import SpliteMap from '@/components/Maps/SpliteMap.vue'
  import turf from "turf";


  export default {
    name: "Home",
    provide(){
        return{
            Home:this// 允许一个祖先组件向其所有子孙后代注入一个依赖，不论组件层次有多深，并在起上下游关系成立的时间里始终生效。
        }
    },
    components: {
      // FlowMonit,
      SearchBar,
      SpliteMap,
      MainMap
    },
    data() {
      return {
        rootUrl:"https://www.jl1mall.com",
        connectStatus: false,

        // 流量记录变量
        isShadow:0,
        canChangeKey:false,
        second: 5,
        timer:"",
        screenHeight:1920,
        showKey:0,
        oldKey:0,
        showCount:0,
        freebackShow:true,
        repositoryId:"",
        mapdialog:false,
        // tk:"",
        tkList:[],
        timeList:[],
        tkName:"",
        // mkList:[],
        calendarShow:false,
        calendarHover:false,
        leftHover:false,
        rightHover:false,
        year:2024,
        //这个月份显示01-12
        month:1,
        //这个月份显示从0-11
        month1:0,
        day:1,
        dayList:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
        monthList:[1,2,3,4,5,6,7,8,9,10,11,12],
        list:[],
        sevenList:[],
        canLeft:true,
        canRight:true,
        dateCanShow:[],
        yearSelect:2024,
        monthSelect:0,
        daySelect:1,
        totalNum:0,
        mkNumList:[],
        canUseCount:100000,
        canUseCountToday:40000,
        totalNumToday:0,
        createTime:"",
        repositoryIdList:[],
        repositoryName:"",
        repositoryListChange:false,
        repositoryListCantChange:true,
        //判断企业版文件接口是否加载完毕
        interfaceSuccess:false,
        // 控制企业版一到四季度文件夹
        enterprise4Quarter:[false,false,false,false],
        //控制企业版里面项目文件夹
        enterpriseProject:[[],[],[],[]],
        //控制区县图
        tabBlockCounty:false,
        // 控制2022全国一张图,进入默认显示
        wholeCounty2022:false,
        wholeCounty2023:true,
        //控制2022各地区图像文件夹
        county2022:[],
        //8个区县列表
        county2022FileList:[],
        //控制2022各地区文件夹里面的内容
        county20224Quarter:[[]],
        projectList:['','','',''],
        quarterList:[],
        countyQuarterList:[],
        countryList:[],
        standardKitList:[],
        haveProject:[false,false,false,false],
        newGuide:0,
        //地图
        showBak:true,
        tk:"",
        // tkList:[],
        // timeList:[],
        mkList:[],
        // mkThumbImg: [
        //   {url:require("../../assets/LayersThumb/0.png")},
        // ],
        tileBaseUrl:'https://api.jl1mall.com',
        // tileBaseUrl:'https://mt.jl1mall.com',
        lyrdata: [],
        mapCtrlTools4Use: [2],
        mapParams: {
            projection:'EPSG:3857', //注意：必须加上此投影才能显示地图，目前有效的是4326和3857，而4490暂未生效
            center:[108.29883, 35.72902], //地图初始化时的中心坐标【基于4326坐标系】
            // center:[142.85524, 43.61710], //地图初始化时的中心坐标【基于4326坐标系】
            // mExtent:[120.45536,35.55856,139.36943,44.78707], //左下点-右上点
            minZoom:1, //可以缩小的最小级别；若此处未定义，地图接收到undefined则表示不受限制
            maxZoom:18, //可以放大的最大级别；若此处未定义，地图接收到undefined则表示不受限制
            zoom:4, //地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
        },
        //卷帘参数
        juanlianOpen: false,
        leftCompareName: '',//卷帘左侧select的值
        rightCompareName: '',//卷帘右侧select的值
        dataList: [],// 卷帘select的选项数据列表

        fakeJuanLianOpen:false,//通用卷帘，假卷帘页面

        myLayersPanelShow:true,
        showMoreToolsPanel:false,
        showMyLayersAndVectorPanel: true,
        showMyLogoPanel: true,
        showRecordPanel: false,
        showIntroductionPanel: true,
        showMoreToolsTipPanel: false,
        showTipPanel: false,

        // 分屏参数
        fenpingOpen: false,
        fenpingName: ['','','',''],//分屏select的值

        // mkListChecked: [],
        checkBoxObj: {
            checkedList: ['2024年度全国高质量一张图'], // 此处需要一个默认值，保证初始选中
            tempCheckedList: ['2024年度全国高质量一张图'], // 此处需要一个默认值，保证初始选中
        },
        checkBoxVectorObj: {
            checkedList: [], // 此处需要一个默认值，保证初始选中
            tempCheckedList: [], // 此处需要一个默认值，保证初始选中
        },

        // 矢量参数
        tableData:[],
        /* 分页参数 */
        ipagination:{
          current: 1,
          pageSize: 1000,
          pageSizeOptions: ['10', '20', '50'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          total: 0,
        },


          layersAndVectorsTabs: ['active', ''],
        loadGisMapRunOver: false,//用于判断mainmap是否加载完成

        overlay: false,
        compareImgs:[],//卷帘可选项
        compareImgsDisabled:[],//卷帘不可选项
        selectedCompareImg: {},
        mapNumberList:[],//审图号列表
        map23:{
          "name": "2023年度全国高质量一张图",
          "type": "mk",
          "content": "73ad26c4aa6957eef051ecc5a15308b4",
          "extent": "73.5013,3.4065,135.0961,53.5632",
          "resolution": "0.5"
        },
      };
    },
    methods: {
      // 没有repositoryId需要改
      commonJuanLian(selectedMk) {
          let item=selectedMk
          this.compareImgs=[]
          this.compareImgsDisabled=[]
          this.selectedCompareImg=''
          this.leftCompareName=item.name+(item.projectName?('-'+item.projectName):'')
          this.rightCompareName=''

          this.dataList = []

          let chineseNum=['一','二','三','四']
          let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）


          // let leftShape = JSON.parse(selectedMk.shape)
          // leftShape=leftShape.type=="MultiPolygon"?turf.multiPolygon(leftShape.coordinates):turf.polygon(leftShape.coordinates)

          this.projectList.forEach((v, index) => {
              if (v) {
                let url=''
                for (let i = 0; i < allLayers.length; i++) {
                  const layer = allLayers[i];
                  if (`2023年第${chineseNum[index]}季度全国高质量一张图` == layer.values_.title) {
                    url = layer.getSource().urls[0]
                    url = url.replace(/&pro.*/,'')
                    break
                  }
                }
                v.forEach(p => {
                  // let geoJson=JSON.parse(p.intersectionGeoJson)
                  // let intersect;
                  // if(geoJson.type=="MultiPolygon"){
                  //     intersect=turf.intersect(leftShape,turf.multiPolygon(geoJson.coordinates));//returns a feature representing the area they share (either a Polygon or MultiPolygon ). If they do not share any area, returns null.
                  // }
                  // if(geoJson.type=="Polygon"){
                  //     intersect=turf.intersect(leftShape, turf.polygon(geoJson.coordinates));//returns a feature representing the area they share (either a Polygon or MultiPolygon ). If they do not share any area, returns null.
                  // }
                  let rightName= `2023年第${chineseNum[index]}季度全国高质量一张图-${p.name}`
                  if (this.leftCompareName!= rightName) {
                    // if (intersect) {
                      this.compareImgs.push({
                          value: rightName,
                          label: rightName,
                          url: url+`&pro=${p.program_id}`
                      })
                      this.dataList.push({
                          value: rightName,
                          label: rightName,
                          url: url+`&pro=${p.program_id}`
                      })
                    // } else {
                    //   this.compareImgsDisabled.push({
                    //       value: rightName,
                    //       label: rightName,
                    //       url: url+`&pro=${p.program_id}`
                    //   })
                    // }
                  }else{//把自己加进去
                    this.dataList.push({
                        value: rightName,
                        label: rightName,
                        url: url+`&pro=${p.program_id}`
                    })
                  }
                })
              }
          })
          this.mkList.forEach(v => {
              let url= `${this.tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=${v.content}&tk=${this.tk}&vf=0`
              if (this.leftCompareName != v.name) {
                if (!/全国/.test(v.name)&&!/全球/.test(v.name)) {
                    this.compareImgs.push({
                        value: v.name,
                        label: v.name,
                        url: url
                    })
                    this.dataList.push({
                        value: v.name,
                        label: v.name,
                        url: url
                    })
                }
                if ('2024年度全国高质量一张图' == v.name) {
                  this.compareImgs.push({
                      value: v.name,
                      label: v.name,
                      url: url
                  })
                  this.dataList.push({
                      value: v.name,
                      label: v.name,
                      url: url
                  })
                }
              }else{//把自己加进去
                this.dataList.push({
                    value: v.name,
                    label: v.name,
                    url: url
                })
              }
          })


          // 关闭无关图层 只保留2022年度全国高质量一张图、左、右、边框、文字标注
          let juanlianRemainLayers=['2024年度全国高质量一张图',this.leftCompareName,this.rightCompareName,'边框']
          allLayers.forEach(layer => {
            if (layer.values_.title!='天地图注记') {
              if (juanlianRemainLayers.includes(layer.values_.title)) {
                layer.setVisible(true)

                if (layer instanceof Vector && layer.values_.title=='边框') {
                  layer.getSource().clear()
                  if (item.content) {
                    this.axios.get(`/tilesapi/tiles/mk/queryMkShape?mk=${item.content}`,{
                      headers: {
                        Authorization: "Bearer " + this.getKey(),
                      },
                    }).then((res) => {
                      if(res.data.code==200){
                        let shape = res.data.msg
                        let geom = JSON.parse(shape)
                        let feature=new Feature({
                          geometry: geom.type=='MultiPolygon'?new MultiPolygon(geom.coordinates):new Polygon(geom.coordinates)
                        })
                        feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
                        layer.getSource().addFeature(feature)
                        let ext = layer.getSource().getExtent()
                        if (this.$refs.mainmap.location.getFeatures().length == 0) {
                          this.$refs.mainmap.map.getView().fit(ext)
                        }
                      }
                    })
                  }
                }
              } else if(layer instanceof Tile){
                layer.setVisible(false)
              }
            }
          })
          this.juanlianOpen=true
          this.fakeJuanLianOpen=true
          this.showMyLayersAndVectorPanel=false
          this.showMyLogoPanel=false
          this.$refs.mainmap.location.clear()
          // this.mapdialog = true
      },
      // 没有repositoryId需要改
      fenping(item) {
        this.fenpingName = ['', '', '', '']
        let substr = item.name.substring(5, 11)
        let reg=new RegExp(substr)
        this.dataList = []
        this.mkList.forEach(v=>{
            if (reg.test(v.name)) {
                let url=`${this.tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=${v.mkIv}&tk=${v.tkIv}&vf=0`
                this.dataList.push({
                    value: v.name,
                    label: v.name,
                    url: url
                })
                for (let i = 0; i < 4; i++) {
                  if (this.fenpingName[i]=='') {
                      this.fenpingName[i] = v.name
                      break
                  }
                }
            }
        })
        // 关闭无关图层 只保留2022年度全国高质量一张图、左、右、边框、文字标注
        let fenpingRemainLayers=['2024年度全国高质量一张图',...this.fenpingName,'边框']
        this.fenpingOpen = true
        this.$nextTick(() => {
          setTimeout(() => {
            for (let i = 0; i < 4; i++) {
              let allLayers = this.$refs.mainmap.mapArr[i].getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
              allLayers.forEach(layer => {
                if (layer.values_.title!=('天地图注记')) {
                  if (fenpingRemainLayers.includes(layer.values_.title)&&this.fenpingName[i]==layer.values_.title) {
                    layer.setVisible(true)
                  } else if(layer instanceof Tile&&layer.values_.title!='2024年度全国高质量一张图'){
                    layer.setVisible(false)
                  } else if (layer instanceof Vector && layer.values_.title=='边框') {
                    layer.getSource().clear()
                    if (!(/全国/.test(item.name)||/全球/.test(item.name))) {
                      this.axios.get(`/tilesapi/tiles/mk/queryMkShape?mk=${item.mkList[0].mkIv}`,{
                        headers: {
                          Authorization: "Bearer " + this.getKey(),
                        },
                      }).then((res) => {
                        if(res.data.code==200){
                          let shape = res.data.msg
                          let geom = JSON.parse(shape)
                          let feature=new Feature({
                            geometry: geom.type=='MultiPolygon'?new MultiPolygon(geom.coordinates):new Polygon(geom.coordinates)
                          })
                          feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
                          layer.getSource().addFeature(feature)
                          let ext = layer.getSource().getExtent()
                          this.$refs.mainmap.mapArr[i].getView().fit(ext)
                        }
                      })
                    }
                  }
                }
              })
            }
          },500)

        })
      },
      fenpingChangeLayer() {
        this.$refs.mainmap.fenpingChangeLayer(this.fenpingName)
      },
      //初始化选中状态
      cancelAllCheck(){
        this.countyQuarterList.forEach(item => {
          item.choose=false
        });
        this.countryList.forEach(item => {
          item.choose=false
        });
        //初始化8个区县
        for(let i=0;i<this.county2022FileList.length;i++){
          this.county20224Quarter[i]=new Array();
          for(let j=0;j<this.county2022FileList[i].mkList.length;j++){
            this.county20224Quarter[i][j]=false
          }
        }
        //初始化企业版
        for(let i=0;i<4;i++){
          this.enterpriseProject[i]=new Array();
          for(let j=0;j<this.projectList[i].length;j++){
            this.enterpriseProject[i][j]=false
          }
        }
      },
      //选中全国一张图
      chinaFree(item) {
        //8个区县，企业版文件夹和区县版文件夹选中全部取消
        this.cancelAllCheck()
        item.choose = true

        let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
        allLayers.forEach(layer => {
          if (layer instanceof Tile&&layer.values_.title!='天地图注记') {
            layer.setVisible(false)
          }
          if (layer.values_.title == item.name) {
            layer.setVisible(true)
          }
          if (layer instanceof Vector && layer.values_.title == '边框') {
            layer.getSource().clear()
          }
        })
        for(let i=0;i<this.mapNumberList.length;i++){
          if(this.mapNumberList[i].mkIv==item.mkIv){
            this.$refs.mainmap.mapReviewNumber = this.mapNumberList[i].mapReviewNumber
            this.$refs.mainmap.mapReviewNumberAbroad = this.mapNumberList[i].mapReviewNumberAbroad
            this.$refs.mainmap.checkMapNumber();
            break
          }
        }
      },
      //8个区县文件夹打开
      openCounty2022(index,i,item){
        //i=1表示打开文件夹；i=0表示关闭文件夹
        if (i == 1) {
          this.county2022[index]=true
        }else{
          this.county2022[index]=false
        }
        this.$forceUpdate();

      },
      //选中8个区县具体某一季度
      openCounty20224Quarter(index, index1, item1,i) {
        //i=1表示打开文件夹；i=0表示关闭文件夹
        if (i == 1) {
          //打开区县默认2023全国一张图选中
          this.chinaFree(this.countryList[0])

          //选中8个区县具体某一季度
          this.county20224Quarter[index][index1] = true

          let needToJump = true,substr1,substr2
          if (this.checkBoxObj.checkedList[1]) {
            substr1 = this.checkBoxObj.checkedList[1].slice(-6)
            substr2 = item1.name.slice(-6)
          }
          needToJump = substr1!=undefined?(substr1 != substr2):true//通过两次选择的图层名后面6个字符判断是否是选择相同的文件夹中的图层

          this.checkBoxObj.checkedList=[this.countryList[0].name,item1.name]
          this.checkBoxObj.tempCheckedList = [this.countryList[0].name,item1.name]

          this.showLayer(item1, needToJump)

          // this.$refs.mainmap.juanlianBtnShow=true
          this.$refs.mainmap.selectedMk=item1
        }else{
          this.county20224Quarter[index][index1]=false
          this.checkBoxObj.checkedList=[this.countryList[0].name]
          this.checkBoxObj.tempCheckedList=[this.countryList[0].name]
          this.showLayer('')
        }

        this.$forceUpdate();
      },
      //打开企业版季度的文件夹
      openEnterprise4Quarter(i,index,item){
        //i=1表示打开文件夹；i=0表示关闭文件夹
        if(i==1){
          this.enterprise4Quarter[index]=true
        }else{
          this.enterprise4Quarter[index]=false
        }
        this.$forceUpdate();

      },
      //选中企业版具体项目
      openEnterpriseProject(item,index,index1,i) {
        //i=1表示打开文件夹；i=0表示关闭文件夹
        let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
          if (i == 1) {
            //8个区县，企业版文件夹和区县版文件夹选中全部取消
            this.cancelAllCheck()
            this.enterpriseProject[index][index1] = true
            this.checkBoxObj.checkedList=[item.name]
            this.checkBoxObj.tempCheckedList=[item.name]

            let biankuangVector
            allLayers.forEach(layer => {
              // console.log('layer.values_.title',layer.values_.title)
              if (layer instanceof Tile&&layer.values_.title!='天地图注记') {
                layer.setVisible(false)
              }
              if (item.name==layer.values_.title) {//收费的图
                let url = layer.getSource().urls[0]
                url=url.replace(/&pro.*/,'')
                layer.getSource().setUrl(url+`&pro=${this.projectList[index][index1].program_id}`);
                layer.setVisible(true)
              }
              if (layer instanceof Vector && layer.values_.title == '边框') {
                biankuangVector=layer
              }
            })
            let geom=JSON.parse(this.projectList[index][index1].intersectionGeoJson)
            let polygon = geom.type == 'MultiPolygon' ? new MultiPolygon(geom.coordinates) : new Polygon(geom.coordinates)
            polygon.transform('EPSG:4326', this.mapParams.projection)
            let feature=new Feature({
              geometry: polygon
            })

            biankuangVector.getSource().clear()
            biankuangVector.getSource().addFeature(feature)

            if (this.$refs.mainmap.location.getFeatures().length==0) {
              this.$refs.mainmap.map.getView().fit(polygon/* , { padding: [120, 450, 120, 120] } */);
            }

            // this.$refs.mainmap.juanlianBtnShow=true
            this.$refs.mainmap.selectedMk = {name:item.name,projectName:this.projectList[index][index1].name,shape:this.projectList[index][index1].intersectionGeoJson}//name,shape必须有
        }
        this.$forceUpdate();

      },
      countySelect(item){
        //8个区县，企业版文件夹和区县版文件夹选中全部取消
        this.cancelAllCheck()
        item.choose = true
        let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
        allLayers.forEach(layer => {
          if (layer instanceof Tile&&layer.values_.title!='天地图注记') {
            layer.setVisible(false)
          }
          if (item.name == layer.values_.title) {
            layer.setVisible(true)
          }
          if (layer instanceof Vector && layer.values_.title == '边框') {
            layer.getSource().clear()
            this.axios.get(`/tilesapi/tiles/mk/queryMkShape?mk=${item.mkIv}&repositoryId=${item.repositoryId}`,{
              headers: {
                Authorization: "Bearer " + this.getKey(),
              },
            }).then((res) => {
              if(res.data.code==200){
                let shape = res.data.msg
                let geom = JSON.parse(shape)
                let feature=new Feature({
                  geometry: geom.type=='MultiPolygon'?new MultiPolygon(geom.coordinates):new Polygon(geom.coordinates)
                })
                feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
                layer.getSource().addFeature(feature)
                let ext = layer.getSource().getExtent()
                if (this.$refs.mainmap.location.getFeatures().length == 0) {
                  this.$refs.mainmap.map.getView().fit(ext)
                }
              }
            })
          }
        })

      },
      //带权限判断的跳转
      jumpWithPermission(type,path,fromUrl){
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
        if(type=='可游客'){
          if(fromUrl){
            window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
          }
          else {
            window.open(this.rootUrl+path,"_self")
          }
        }else if(type=='仅登录'){
          //已登录
          if(loginUserId){
            if(fromUrl){
              window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
            }
            else {
              window.open(this.rootUrl+path,"_self")
            }
          }
          //未登录
          else {
            if(fromUrl){
              window.open(this.rootUrl+'/Login'+"?fromUrl="+this.rootUrl+fromUrl,"_self")
            }
            else {
              window.open(this.rootUrl+'/Login',"_self")
            }
          }
          } else if (type == '仅实名') {

          //已登录
          if(loginUserId){
            //已实名
            if(authentication=='0'){
              if(fromUrl){
                window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
              }
              else {
                window.open(this.rootUrl+path,"_self")
              }
            }else if(type=='仅登录'){
              //已登录
              if(loginUserId){
                if(fromUrl){
                  window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
                }
                else {
                  window.open(this.rootUrl+path,"_self")
                }
              }
              //未登录
              else {
                if(fromUrl){
                  window.open(this.rootUrl+'/Login'+"?fromUrl="+this.rootUrl+fromUrl,"_self")
                }
                else {
                  window.open(this.rootUrl+'/Login',"_self")
                }
              }
            }else if(type=='仅实名'){
              //已登录
              if(loginUserId){
                //已实名
                if(authentication=='0'){
                  if(fromUrl){
                    window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
                  }
                  else {
                    window.open(this.rootUrl+path,"_self")
                  }
                }
                //未实名
                else {
                  window.open(this.rootUrl+'/Authentication',"_self")
                }

              }
              //未登录
              else {
                if(fromUrl){
                  window.open(this.rootUrl+'/Login'+"?fromUrl="+this.rootUrl+fromUrl,"_self")
                }
                else {
                  window.open(this.rootUrl+'/Login',"_self")
                }
              }
            }
            //未实名
            else {
              window.open(this.rootUrl+'/Authentication',"_self")
            }

          }
          //未登录
          else {
            if(fromUrl){
              window.open(this.rootUrl+'/Login'+"?fromUrl="+this.rootUrl+fromUrl,"_self")
            }
            else {
              window.open(this.rootUrl+'/Login',"_self")
            }
          }
        }
      },
      getKey() {
        return localStorage.getItem("token");
      },
      getLoginInfo() {
        let that = this;
        this.axios
            .get("/loginapi/getLoginInfo", {
              headers: {
                'Cache-Control': 'no-cache',
                Authorization: "Bearer " + this.getKey(),
              },
            })
            .then((res) => {
              if (res.data.success) {
                console.log("主页顶bar，getLoginInfo信息");
                this.print(res.data);
                this.$store.state.user.userId = res.data.data.account;
                this.$store.state.user.name = res.data.data.name;
                this.$store.state.user.vipLevel = res.data.data.vipLevel;
                this.setCookie("userId", res.data.data.account);
                this.setCookie(
                    "userInfo",
                    JSON.stringify({
                      phone: res.data.data.phone,
                      location: res.data.data.location,
                    })
                );
                this.$store.state.user.logined = true;
                let authentication = res.data.data.authentication
                this.$store.state.user.authentication =authentication; //是否实名认证，0是，1否
                this.setLocalStorageItem("authentication",authentication); //是否实名认证，0是，1否;为方便其他系统用
                this.setLocalStorageItem('token',res.data.data.key); //getuserInfo也需要赋值token，为把三部token替换为本部门token
                this.authenticationStatus=res.data.data.authentication
                this.vipLevel = res.data.data.vipLevel;
                this.vipType = res.data.data.vipType;
                this.vipActivityStatus = res.data.data.vipActivityStatus;
                this.avatar = res.data.data.avatar;
                if (res.data.data.endTime) {
                  this.vip_endTime = res.data.data.endTime.split(" ")[0];
                }
              } else {
                this.$store.state.user.logined = false;
                // if (that.getCookie("userId")) {
                  setTimeout(() => {
                    this.$store.state.user.userId = "";
                    // this.setCookie('userId', "");
                    localStorage.setItem("userId", "");
                    // this.$router.push("/Login");
                    this.jumpWithPermission('仅实名','/rskit/viewMapSource','/rskit/viewMapSource')
                  }, 2000);
                // }
              }
            });
      },
      setLocalStorageItem(key, value) {
        localStorage.setItem(key, value);
      },
      getIfTimeout(){
          let that=this;
          that.axios
              .get("/loginapi/getLoginInfo", {
                  headers: {
                  Authorization: "Bearer " + this.getKey(),
                  },
              })
              .then((res) => {
                  this.print(res)
                  if (res.data.success) {
                  this.$store.state.user.userId = res.data.data.account;
                  this.$store.state.user.name = res.data.data.name;
                  this.$store.state.user.vipLevel = res.data.data.vipLevel;
                  this.setCookie("userId", res.data.data.account);
                  this.setCookie(
                      "userInfo",
                      JSON.stringify({
                          phone: res.data.data.phone,
                          location: res.data.data.location,
                      })
                  );
                  this.$store.state.user.logined = true;
                  this.avatar = res.data.data.avatar;
                  this.teacherStatus=res.data.data.teacherStatus;
                  this.messageStatus=res.data.data.messageStatus;
                  this.graduationStatus=res.data.data.graduationStatus;
                  this.excellent=res.data.data.excellent;
                  } else {
                  this.$store.state.user.logined = false;
                      if (that.getCookie("userId")) {
                          setTimeout(() => {
                          this.$store.state.user.userId = "";
                          localStorage.setItem("userId", "");
                          this.$router.push("/Login");
                          }, 2000);
                      }
                  }
              });
      },
      // 没有repositoryId需要改
      juanlian(item,list){
          this.leftCompareName=''
          this.rightCompareName=''
          this.leftCompareName=item.name

          this.dataList=[]
          list.forEach(v=>{
            let url=`${this.tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=${v.mkIv}&tk=${v.tkIv}&vf=0`
            this.dataList.push({
                value: v.name,
                label: v.name,
                url: url
            })
            if (v.name!=this.leftCompareName&&!this.rightCompareName) {
                this.rightCompareName=v.name
            }
          })

          // 关闭无关图层 只保留2022年度全国高质量一张图、左、右、边框、文字标注
          let juanlianRemainLayers=['2024年度全国高质量一张图',this.leftCompareName,this.rightCompareName,'边框']
          let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
          allLayers.forEach(layer => {
            if (layer.values_.title!='天地图注记') {
              if (juanlianRemainLayers.includes(layer.values_.title)) {
                layer.setVisible(true)

                if (layer instanceof Vector && layer.values_.title=='边框') {
                  layer.getSource().clear()
                  if (item.mkIv&&!item.name.includes('全球')&&!item.name.includes('全国高质量一张图')) {
                    this.axios.get(`/tilesapi/tiles/mk/queryMkShape?mk=${item.mkIv}`,{
                      headers: {
                        Authorization: "Bearer " + this.getKey(),
                      },
                    }).then((res) => {
                      if(res.data.code==200){
                        let shape = res.data.msg
                        let geom = JSON.parse(shape)
                        let feature=new Feature({
                          geometry: geom.type=='MultiPolygon'?new MultiPolygon(geom.coordinates):new Polygon(geom.coordinates)
                        })
                        feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
                        layer.getSource().addFeature(feature)
                        let ext = layer.getSource().getExtent()
                        if (this.$refs.mainmap.location.getFeatures().length == 0) {
                          this.$refs.mainmap.map.getView().fit(ext)
                        }
                      }
                    })
                  }
                }
              } else if(layer instanceof Tile){
                layer.setVisible(false)
              }
            }
          })
          this.juanlianOpen=true
          this.showMyLayersAndVectorPanel=false
          this.showMyLogoPanel=false
          this.$refs.mainmap.location.clear()
          // this.mapdialog = true

        this.$refs.mainmap.toggleJL(this.leftCompareName,this.rightCompareName)
      },
      closeJL() {
        this.juanlianOpen = false;
        this.fakeJuanLianOpen = false;
        this.showMyLayersAndVectorPanel=true
        this.showMyLogoPanel=true
        this.$refs.mainmap.flagJL = false;
        this.$refs.mainmap.toggleJL(this.leftCompareName, this.rightCompareName)

        let mk
        for (let i = 0; i < this.mkList.length; i++) {
          let temp = this.mkList[i];
          if (temp.name == this.checkBoxObj.checkedList[this.checkBoxObj.checkedList.length-1]) {
            mk = temp
            break
          }
        }
        this.showLayer(mk)

      },
      changeMaps(position) {
          if (position == 'left') {
              for (let i = 0; i < this.dataList.length; i++) {
                  if (this.leftCompareName == this.dataList[i].label) {
                      let newUrl = this.dataList[i].url
                      this.$refs.mainmap.JLLeftlyr.getSource().setUrl(newUrl)
                      // this.$refs.mainmap.swipe.layers[0].layer.getSource().setUrl(newUrl)
                      break;
                  }
              }
          } else if (position == 'right') {
              for (let i = 0; i < this.dataList.length; i++) {
                  if (this.rightCompareName == this.dataList[i].label) {
                      let newUrl = this.dataList[i].url
                      this.$refs.mainmap.JLRightlyr.getSource().setUrl(newUrl)
                      // this.$refs.mainmap.swipe.layers[1].layer.getSource().setUrl(newUrl)
                      break;
                  }
              }
          } else {
              console.log("有问题")
          }
      },
      // 全面修改获取列表展示逻辑，所有套件图源统一处理
      orderList(){
          this.axios.get("/tilesapi/tiles/repository/queryViewMapRepositoryMkDir",{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((res) => {
            let result = res.data.data
            this.mkList=[]
            if (res.data.code==200) {
              let tempTK = ''
              result.forEach(data => {
                // 判断全国一张图
                if(!data.name){
                  console.log('异常图源',data)
                }
                else if(data.name.includes('全球')||data.name.includes('全国高质量一张图')||data.name.includes('全国季度一张图')){
                  // 判断是季度图文件夹
                  if(data.name.includes('（')&&!data.name.includes('标准版')){
                    data.mkList.forEach(mapItem => {
                      mapItem.choose = false
                      this.quarterList.push(mapItem)
                      this.mkList.push(mapItem)
                    });
                  }
                  // else if(data.name.includes('（标准版')){
                  //   data.mkList.forEach(mapItem => {
                  //     mapItem.choose = false
                  //     if(this.countryList.length==0){//初始展示第一张图
                  //       mapItem.choose = true
                  //       tempTK = mapItem.tkIv
                  //     }
                  //     this.countryList.push(mapItem)
                  //     this.mkList.push(mapItem)
                  //   });
                  // }
                  else{ //其余为单张全球一张图
                    data.mkList.forEach(mapItem => {
                      mapItem.choose = false
                      if(this.countryList.length==0){//初始展示第一张图
                        mapItem.choose = true
                        tempTK = mapItem.tkIv
                      }
                      this.countryList.push(mapItem)
                      this.mkList.push(mapItem)
                    });
                  }
                }
                // 判断为22年八区县四季度文件夹
                else if(data.name.includes('每季度影像')){
                  this.county2022FileList.push(data)
                  data.mkList.forEach(mapItem => {
                    mapItem.choose = false
                    this.mkList.push(mapItem)
                  });
                }
                // 其余情况为
                else{
                  data.mkList.forEach(mapItem => {
                    mapItem.choose = false
                    this.countyQuarterList.push(mapItem)
                    this.mkList.push(mapItem)
                  });
                }
              });
              //将企业版全部项目存储
              let count =0
              for(let i=0;i<this.quarterList.length;i++){
                let param=new FormData();
                param.append('repository_id',this.quarterList[i].repositoryId);
                param.append('mk_iv',this.quarterList[i].mkIv);
                this.axios.post("/map_service_back/program/getProgramIdByRepAndMk", param, {
                  headers: {
                      Authorization: "Bearer " + this.getKey(),
                  },
                }).then(res => {
                  let data = res.data.data
                  if(data.length==0){
                    this.haveProject[i]=false
                  }else{
                    this.haveProject[i]=true
                    this.projectList[i]=data
                    //企业版项目初始化
                    this.enterpriseProject[i]=new Array();
                    for(let j=0;j<this.projectList[i].length;j++){
                      this.enterpriseProject[i][j]=false
                    }
                  }
                  count++
                  if(count==this.quarterList.length){
                    this.interfaceSuccess=true
                    this.$forceUpdate()
                  }
                })
              }
              // 初始化8个区县文件夹以及里面子文件夹
              for(let i=0;i<this.county2022FileList.length;i++){
                this.county2022[i]=false
                this.county20224Quarter[i]=new Array();
                for(let j=0;j<this.county2022FileList[i].mkList.length;j++){
                  this.county20224Quarter[i][j]=false
                }
              }
              // 获取每个图层审图号
              this.axios.get("/tilesapi/tiles/mk/getMapReviewNumberList")
                .then((res) => {
                  this.mapNumberList = res.data.data
                })
              // 添加所有图层
              this.lyrdata = []
              this.mkList.forEach(v => {
                let temp = {
                    lyrType:"Tile",
                    srcType:"XYZ",
                    mUrl:`${this.tileBaseUrl}/getMap/{z}/{x}/{-y}?mk=${v.mkIv}&tk=${v.tkIv}&vf=0`,
                    mTitle:v.name,
                    mName:v.name,
                    mExtent:v.extent?v.extent.split(','):[],
                    mVisible:v.choose
                }
                this.lyrdata.push(temp)
              })
              this.lyrdata.push({
                  lyrType:"lVector",
                  srcType:"Vector",
                  mUrl:'',
                  mTitle:"边框",
                  mName:"边框",
                  mVisible:true
              })
              this.tk = tempTK
              // 如果没有tk则跳转申请体验版
              if(!tempTK) this.linkToTrial()
            }
          })
      },
      //判断当前选中日期的总访问次数
      getTodayTotalNum(day){
          if(this.tkName=='体验版'){
              if(this.sevenList[day]==0){
                  this.canUseCount=40000
              }else if(this.sevenList[day]==1){
                  this.canUseCount=100000
              }else if(this.sevenList[day]==2){
                  this.canUseCount=3000000
              }
          }else if(this.tkName=='企业版'){
              this.canUseCount=3000000
          }else{
            this.canUseCount=500000
          }

      },
      //初始化获取当前日期
      getDate(){
          var date = new Date()
          this.year = date.getFullYear() // 获取年
          var month = date.getMonth() + 1 // 获取月
          this.month1=date.getMonth()
          this.day = date.getDate() // 获取日
          if(month<10){
              this.month="0"+month
          }else{
              this.month = month
          }
          if(this.year==2024 && this.month1==0){
              this.canLeft=false
          }else if(this.year==2026 && this.month1==11){
              this.canRight=false
          }else{
              this.canRight=true
              this.canLeft=true
          }
          this.dateShowJudge()
          this.yearSelect=this.year
          this.monthSelect=this.month1
          this.daySelect=this.day

      },
      //判断每个月展示多少天
      dateShowJudge(){
          for(let i=0;i<31;i++){
              this.dateCanShow[i]=true
          }
          if((this.year==2026||this.year==2025)&&this.month1==1){
              this.dateCanShow[28]=false
              this.dateCanShow[29]=false
          }
          if(this.year==2024&&this.month1==1){
              this.dateCanShow[29]=false
          }
          if(this.month1==1||this.month1==3||this.month1==5||this.month1==8||this.month1==10){
              this.dateCanShow[30]=false
          }
      },
      //左右箭头改变年月
      changeDate(i){
          if(i==0){
              if(this.month1==0){
                  this.year--
                  this.month1=11
              }else{
                  this.month1--
              }
          }else if(i==1){
              if(this.month1==11){
                  this.year++
                  this.month1=0
              }else{
                  this.month1++
              }
          }
          if(this.year==2024 && this.month1==0){
              this.canLeft=false
          }else if(this.year==2026 && this.month1==11){
              this.canRight=false
          }else{
              this.canRight=true
              this.canLeft=true
          }
          this.getEmpty()
          this.dateShowJudge()
          this.getDateData(this.repositoryId,this.year,this.month1+1)

      },
      //日历选择年份
      changeYear(i){
          this.year=i
          this.getEmpty()
          this.dateShowJudge()
          this.getDateData(this.repositoryId,this.year,this.month1+1)
      },
      //日历选择月份
      changeMonth(index){
          this.month1=index
          if(this.year==2024 && this.month1==0){
              this.canLeft=false
          }else if(this.year==2026 && this.month1==11){
              this.canRight=false
          }else{
              this.canRight=true
              this.canLeft=true
          }
          this.getEmpty()
          this.dateShowJudge()
          this.getDateData(this.repositoryId,this.year,this.month1+1)
      },
      //选择某个日期,变成全部蓝色圆
      changeColor(index){
          this.yearSelect=this.year
          this.monthSelect=this.month1
          this.daySelect=index+1
          this.day = index+1
          this.getTodayTotalNum(index)
          this.geryExist()
          let countCircleNum = document.getElementById("countCircle" + index);
          let countCircleNums = document.getElementById("countCircles" + index);
          if(countCircleNum.style.background=='conic-gradient(rgb(42, 42, 42) 0%, rgb(42, 42, 42) 100%)'){
                  countCircleNum.style.background="conic-gradient(#1E81EB  0% 100%)"
          }
          countCircleNums.style.backgroundColor="#1E81EB"
          countCircleNums.style.color="#fff"
          this.totalNum=this.list[index]
          this.getMkData(this.repositoryId,this.yearSelect,this.monthSelect+1,this.daySelect)

      },
      //判断灰色圆环是否显示
      geryExist(){
          let createYear=this.createTime.substring(0,4)
          let createMonth=""
          let createMonth1=this.createTime.substring(5,6)
          let createMonth2=this.createTime.substring(6,7)
          if(createMonth1==0||createMonth1=='0'){
            createMonth=createMonth2
          }else{
            createMonth=this.createTime.substring(5,7)
          }
          let createDay=""
          let createDay1=this.createTime.substring(8,9)
          let createDay2=this.createTime.substring(9,10)
          if(createDay1==0||createDay1=='0'){
            createDay=createDay2
          }else{
            createDay=this.createTime.substring(8,10)
          }
          let createTime = createYear+"-"+createMonth+"-"+ createDay
          var date = new Date()
          let year = date.getFullYear() // 获取年
          let month=date.getMonth()+1//获取月
          let day = date.getDate() // 获取日
          let list =[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
          if(this.list.length>1){
            for(let i=0;i<this.list.length;i++){
                list[i]=this.list[i]
            }
          }
          let count = 40000
          if(this.tkName=='体验版'){
              if(this.sevenList[this.daySelect-1]==0){
                this.canUseCount=40000
              }else if(this.sevenList[this.daySelect-1]==1){
                this.canUseCount=100000
              }else if(this.sevenList[this.daySelect-1]==2){
                this.canUseCount=3000000
              }
              for(let i=0;i<this.list.length;i++){
              if(this.sevenList[i]==0){
                  count=40000
              }else if(this.sevenList[i]==1){
                  count=100000
              }else if(this.sevenList[i]==2){
                  count=3000000
              }
              if(list[i]<count){
                  list[i]=(list[i]/count)*100
              }else{
                  list[i]=100
              }
              }
          }else if(this.tkName=='企业版'){
              this.canUseCount=3000000
              for(let i=0;i<this.list.length;i++){
                  count = 3000000
                  if(list[i]<count){
                      list[i]=(list[i]/count)*100
                  }else{
                      list[i]=100
                  }
              }
          }else{
            this.canUseCount=500000
              for(let i=0;i<this.list.length;i++){
                  count = 500000
                  if(list[i]<count){
                      list[i]=(list[i]/count)*100
                  }else{
                      list[i]=100
                  }
              }
          }
          let dayFor=""
          for(let i=0;i<31;i++){
              let countCircleNum = document.getElementById("countCircle" + i);
              let countCircleNums = document.getElementById("countCircles" + i);
              let today = year+"-"+month+"-"+day
              let month1 = this.month1+1
              let j=i+1
              dayFor=this.year+"-"+month1+"-"+ j
              var a1 = Date.parse(new Date(dayFor));
              var a2 = Date.parse(new Date(today));
              var a3 = Date.parse(new Date(createTime));
              var dayCount1 = parseInt((a1-a2)/ (1000 * 60 * 60 * 24));//核心：时间戳相减，然后除以天数
              var dayCount2= parseInt((a3-a1)/ (1000 * 60 * 60 * 24));//核心：时间戳相减，然后除以天数
              if(dayCount1<=0&&dayCount2<=0){
                if(list[i]==100){
                  countCircleNum.style.background="conic-gradient(#49C2FF 0% 100%)"
                }else{
                  countCircleNum.style.background="conic-gradient(#49C2FF  0% "+list[i]+"%,#fff "+list[i]+"% 100%)"
                }
                countCircleNums.style.backgroundColor="rgb(42 42 42)"
                countCircleNums.style.color="#fff"
              }else{
                countCircleNum.style.background="conic-gradient(rgb(42 42 42)  0% 100%)"
                countCircleNums.style.backgroundColor="rgb(42 42 42)"
                countCircleNums.style.color="#fff"
              }
          }
      },
      //切换月份时圆环先变成空白
      getEmpty(){
          for(let i=0;i<31;i++){
              let countCircleNum = document.getElementById("countCircle" + i);
              let countCircleNums = document.getElementById("countCircles" + i);
              countCircleNum.style.background="conic-gradient(rgb(42 42 42)  0% 100%)"
              countCircleNums.style.backgroundColor="rgb(42 42 42)"
              countCircleNums.style.color="#fff"
          }
      },
      //按日期请求数据
      getDateData(repositoryId,year,month){
          let inputForm = new FormData();
          inputForm.append("repositoryId",repositoryId);
          inputForm.append("year",year);
          inputForm.append("month",month);
          this.axios.post("/tilesapi/tiles/flow/queryUserPerDayFlow",inputForm, {
                  headers: {
                  Authorization: "Bearer " + this.getKey(),
                  },
              }).then((res)=>{
                  let data = res.data.data
                  this.list=data.userUseDayFlowList
                  this.sevenList=data.userRepDateList
                  if(this.yearSelect==year&&this.month1==this.monthSelect){
                      this.totalNum=this.list[this.daySelect-1]
                  }
                  this.geryExist()
                  let index = this.daySelect-1
                  if(this.yearSelect==this.year&&this.monthSelect==this.month1){
                      let countCircleNum = document.getElementById("countCircle" + index);
                      let countCircleNums = document.getElementById("countCircles" + index);
                      countCircleNum.style.background="conic-gradient(#1E81EB  0% 100%)"
                      countCircleNums.style.backgroundColor="#1E81EB"
                      countCircleNums.style.color="#fff"
                  }
              })
      },
      getDateData1(repositoryId,year,month){
          let inputForm = new FormData();
          inputForm.append("repositoryId",repositoryId);
          inputForm.append("year",year);
          inputForm.append("month",month);
          this.axios.post("/tilesapi/tiles/flow/queryUserPerDayFlow",inputForm, {
                  headers: {
                  Authorization: "Bearer " + this.getKey(),
                  },
              }).then((res)=>{
                console.log(res);
                  let data = res.data.data
                  this.list=data.userUseDayFlowList
                  console.log(this.list)
                  this.sevenList=data.userRepDateList
                  if(this.tkName=='体验版'){
                      var date = new Date()
                      var day = date.getDate()
                      if(this.sevenList[day-1]==0){
                          this.canUseCountToday=40000
                      }else if(this.sevenList[day-1]==1){
                          this.canUseCountToday=100000
                      }else if(this.sevenList[day-1]==2){
                          this.canUseCountToday=3000000
                      }
                  }else if(this.tkName=='企业版'){
                      this.canUseCountToday=3000000
                  }else{
                    this.canUseCountToday=500000
                  }
                  this.getTodayTotalNum(this.day-1)
                  this.totalNumToday=this.list[this.daySelect-1]
                  this.totalNum=this.list[this.daySelect-1]
                  this.geryExist()
                  this.changeColor(this.day-1)
              })
      },
      //按日期请求MK流量统计
      getMkData(repositoryId,year,month,day){
          let inputForm = new FormData();
          inputForm.append("repositoryId",repositoryId);
          inputForm.append("year",year);
          inputForm.append("month",month);
          inputForm.append("day",day);
          this.axios.post("/tilesapi/tiles/flow/queryUserPerMkFlow",inputForm, {
                  headers: {
                  Authorization: "Bearer " + this.getKey(),
                  },
              }).then((res)=>{
                  let data = res.data.data
                  this.mkNumList=data
              })
      },

      showMyLayers(){
        this.layersAndVectorsTabs=['active','']
        this.myLayersPanelShow = true

        // 跳转到全国，显示高质量一张图
        // let mk=this.mkList[0]

        // 跳转到后勾选的图
        let mk = this.mkList.find(v => v.name==this.checkBoxObj.checkedList[this.checkBoxObj.checkedList.length-1])
        // console.log('mk',mk)
        this.showLayer(mk)
      },
      showMyVectors(){
        this.layersAndVectorsTabs=['','active']
        this.myLayersPanelShow = false

        // 显示勾选的并跳转
        if (this.tableData.length > 0) {
          let vector = this.tableData.find(v => {
            if (this.checkBoxVectorObj.checkedList.length>0) {
              return v.name == this.checkBoxVectorObj.checkedList[this.checkBoxVectorObj.checkedList.length - 1]
            }
          })
          console.log('vector',vector)
          if (vector) {
            this.overlay=true

            let param=new FormData();
            param.append('id',vector.id)
            this.axios.post("/map_service_back/vectorLibrary/getVectorDetail", param)
            .then((response) => {
              this.overlay=false

              let shape = response.data.data.geojson
              if (shape) {
                let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
                allLayers.forEach(layer => {
                  if (layer instanceof Vector && layer.values_.title=='边框') {
                    layer.getSource().clear()
                    let geom = JSON.parse(shape)
                    let geometry
                    // TODO 加上点
                    if (geom.type=='MultiPolygon') {
                      geometry=new MultiPolygon(geom.coordinates)
                    }
                    if (geom.type == 'Polygon') {
                      geometry=new Polygon(geom.coordinates)
                    }
                    if (geom.type == 'LineString') {
                      geometry=new LineString(geom.coordinates)
                    }
                    if (geom.type == 'MultiLineString') {
                      geometry=new MultiLineString(geom.coordinates)
                    }
                    let feature=new Feature({
                      geometry: geometry
                    })
                    feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
                    layer.getSource().addFeature(feature)
                    let ext = layer.getSource().getExtent()
                    if (this.$refs.mainmap.location.getFeatures().length == 0) {
                        this.$refs.mainmap.map.getView().fit(ext)
                    }
                  }
                })
              }

            })

          }

        }



      },
      async onVectorChangeOption(checkedList) {
        if (checkedList.length < 1) { // 实现必须有一个选中的效果
            this.checkBoxVectorObj.checkedList = this.checkBoxVectorObj.tempCheckedList; // 点击选中项不能取消选中
            return;
        }

        checkedList = checkedList.slice(1); // 实现单选效果

        // console.log('checkedList',checkedList)
        this.checkBoxVectorObj.tempCheckedList = checkedList; // 缓存当前选中项，在取消选中时使用
        this.checkBoxVectorObj.checkedList = checkedList; // 更新选中

        let shape=''
        for (let i = 0; i < this.tableData.length; i++) {
          let vec = this.tableData[i];
          if (vec.name==checkedList[0]) {
            // shape=vec.shape
            this.overlay=true
            let param=new FormData();
            param.append('id',vec.id)
            await this.axios.post("/map_service_back/vectorLibrary/getVectorDetail", param)
              .then((response) => {
                this.overlay=false
                shape = response.data.data.geojson
              })
            break
          }
        }


        let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
        allLayers.forEach(layer => {
          if (layer instanceof Vector && layer.values_.title=='边框') {
            layer.getSource().clear()
            let geom = JSON.parse(shape)
            let geometry
            if (geom.type=='MultiPolygon') {
              geometry=new MultiPolygon(geom.coordinates)
            }
            if (geom.type == 'Polygon') {
              geometry=new Polygon(geom.coordinates)
            }
            if (geom.type == 'LineString') {
              geometry=new LineString(geom.coordinates)
            }
            if (geom.type == 'MultiLineString') {
              geometry=new MultiLineString(geom.coordinates)
            }
            let feature=new Feature({
              geometry: geometry
            })
            feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
            layer.getSource().addFeature(feature)
            let ext = layer.getSource().getExtent()
            if (this.$refs.mainmap.location.getFeatures().length == 0) {
                this.$refs.mainmap.map.getView().fit(ext)
            }
          }

        })
      },
      // repositoryId不存在需要改
      showLayer(mk, needToZoom = true) {
        console.log(this.checkBoxObj);
        console.log('this.checkBoxObj.checkedList', this.checkBoxObj.checkedList)
        let allLayers
        if (this.fenpingOpen) {
          allLayers = this.$refs.mainmap.mapArr[1].getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
        } else {
          allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
        }
        let mkiv=''
        allLayers.forEach(layer => {
          if (layer.values_.title!='天地图注记') {
            if (this.checkBoxObj.checkedList.includes(layer.values_.title)) {
              layer.setVisible(true)
              mkiv = layer.getSource().urls[0].match(/mk=.+?(?=&)/i)[0].split('=')[1]
              // layer.setVisible(!layer.getVisible())
            } else if(layer instanceof Tile){
              layer.setVisible(false)
            }

            if (layer instanceof Vector && layer.values_.title=='边框') {
              layer.getSource().clear()
              if (mk&&!(/全国/.test(mk.name)||/全球/.test(mk.name))) {//全国显示边框
                this.axios.get(`/tilesapi/tiles/mk/queryMkShape?mk=${mk.mkIv}`,{
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then((res) => {
                  if(res.data.code==200){
                    let shape = res.data.msg
                    let geom = JSON.parse(shape)
                    let feature = new Feature({
                      geometry: geom.type == 'MultiPolygon' ? new MultiPolygon(geom.coordinates) : new Polygon(geom.coordinates)
                    })
                    feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
                    layer.getSource().addFeature(feature)
                    if (needToZoom) {
                      let ext = layer.getSource().getExtent()
                      if (this.$refs.mainmap.location.getFeatures().length == 0) {
                        if (this.fenpingOpen) {
                          this.$refs.mainmap.mapArr[1].getView().fit(ext)
                        } else {
                          this.$refs.mainmap.map.getView().fit(ext)
                        }
                      }
                    }
                  }
                })
              }
            }

          }
        })
        for(let i=0;i<this.mapNumberList.length;i++){
          if(this.mapNumberList[i].mkIv==mkiv){
            this.$refs.mainmap.mapReviewNumber = this.mapNumberList[i].mapReviewNumber
            this.$refs.mainmap.mapReviewNumberAbroad = this.mapNumberList[i].mapReviewNumberAbroad
            this.$refs.mainmap.checkMapNumber();
            break
          }
        }
      },
      showMoreTools() {
        this.showMoreToolsPanel=true
      },
      //我的矢量列表
      getVectorLibrary(){
        let param=new FormData();
        param.append('pageNum',this.ipagination.current);
        param.append('pageSize',this.ipagination.pageSize);
        this.axios
        .post("/map_service_back/vectorLibrary/getVectorLibrary", param,{
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        }).then((response) => {
          console.log(response)
          if (response.data.code==200) {
            this.tableData=response.data.data;
            this.ipagination.total=response.data.total;
            // this.checkBoxVectorObj.checkedList=[]
            // this.checkBoxVectorObj.tempCheckedList = []
            this.checkBoxVectorObj.checkedList=[this.tableData.length>0?this.tableData[0].name:'']
            this.checkBoxVectorObj.tempCheckedList = [this.tableData.length>0?this.tableData[0].name:'']
          }
        })
      },
      linkToTrial() {
        this.$router.push({path: "/Purchase",query: {'processType':1}});
      },
      linkToKnow() {
        window.open("https://www.jl1mall.com/rskit/Price"); //打开一个新的标签页
      },
      //新手指导
      firstGuide(){
        let inputForm = new FormData();
        inputForm.append("repositoryId",this.repositoryId);
        this.axios.post("/tilesapi/tiles/guide/queryRepositoryGuideStatus",inputForm, {
                headers: {
                Authorization: "Bearer " + this.getKey(),
                },
        }).then((res) => {
              let data = res.data.data
              if(data&&data.guideLab==0){
                this.newGuide=1
                this.axios.post("/tilesapi/tiles/guide/updateLab",inputForm, {
                        headers: {
                        Authorization: "Bearer " + this.getKey(),
                        },
                }).then((res) => {
                      console.log(res);
                    })
              }else{
                this.newGuide=0
              }
            })
      },
      getTodayTime() {
        let dateTime = new Date();
        let year = dateTime.getFullYear();
        let month = dateTime.getMonth() + 1;
        if(month< 10){ month="0" +month }
        let ri = dateTime.getDate();
        if(ri< 10){ ri="0" +ri }
        let hours = dateTime.getHours();
        if(hours< 10){ hours="0" +hours }
        let minutes=dateTime.getMinutes();
        if(minutes< 10){ minutes="0" +minutes }
        let seconds=dateTime.getSeconds();
        if (seconds < 10) { seconds = "0" + seconds }
        let time = year + "-" + month + "-" + ri + " " + hours + ":" + minutes + ":" + seconds
        return time;
      },
      // 这个函数需要改一下 repositoryName不存在了
      showStateLayer(){
        this.countyQuarterList.forEach(county => {
          if(county.name==this.repositoryName){
            this.countySelect(county)
          }
        });
      }
    },
    created() {
      //如果从商城端跳入，同步token状态
      let token=this.$route.query.tk;
      if(token){
        this.setLocalStorageItem('token',token);
      }
      this.getLoginInfo();
      //定时判断用户登录状态，每分钟一次，如果是登录超时则返回登录页
      this.$nextTick(() => {
        setInterval(this.getIfTimeout, 600000);
      });
    },
    mounted() {
      // this.createTime= this.$store.state.createTime
      // this.repositoryId= this.$store.state.repositoryId
      // this.repositoryName= this.$store.state.repositoryName

      //矢量
      this.getVectorLibrary()
      bus.$off('loadGisMapRunOver')
      bus.$on('loadGisMapRunOver', () => {
        this.showBak = false
        this.$refs.mainmap.curTk = this.tk
        this.loadGisMapRunOver=true
        if(this.repositoryName!='') this.showStateLayer()
      })
      bus.$off('commonJuanLian')
      bus.$on('commonJuanLian', (selectedMk) => {
        this.commonJuanLian(selectedMk)
      })
      this.orderList()
      // this.getDate()
    },
    computed: {
      items() {
            let tmp = []
            tmp = tmp.concat(this.latLng)
            tmp.push(...this.poiResult)
            return tmp
        }
    },
    watch: {
        selectedCompareImg(val, oldVal) {
          if (val) {
            let leftName=this.leftCompareName.replace(/-.*/,'')
            this.$refs.mainmap.toggleJL(leftName, this.selectedCompareImg)
            this.fakeJuanLianOpen = false
            this.rightCompareName = this.selectedCompareImg
          }
        },
        month1:function(val,oldVal){
            val++
            if(val<10){
                this.month="0"+val
            }else{
                this.month = val
            }
        },

        keyword(){
            this.keyword=this.keyword || '';
            this.keyword = this.keyword.replace(/，/g, ',')
            var t1 = /^-?[0-9]*\.?[0-9]*,|，.-?[0-9]*\.?[0-9]*$/
            this.latLng = []
            if(this.keyword.match(t1)!== null){
                let tmp = this.keyword.split(',')
                let tmp0 = parseFloat(tmp[0])
                let tmp1 = parseFloat(tmp[1])
                if(tmp.length === 2 && !isNaN(tmp1) && !isNaN(tmp0)){
                    if(tmp1>=-90 && tmp1<=90 && tmp0>=-180 && tmp0<=180) {
                        this.latLng.push({
                            name:'经度' + tmp0 + ', ' + '纬度' + tmp1,
                            detail: '经纬度来源：WGS84坐标系',
                            location: [ tmp0, tmp1]
                        })
                        this.latLng.push({
                            name:'经度' + tmp0 + ', ' + '纬度' + tmp1,
                            detail: '经纬度来源：百度地图',
                            location: [ tmp0, tmp1]
                        })
                        this.latLng.push({
                            name:'经度' + tmp0 + ', ' + '纬度' + tmp1,
                            detail: '经纬度来源：高德地图/谷歌地图',
                            location: [ tmp0, tmp1]
                        })
                    }
                    if(tmp1>=-180 && tmp1<=180 && tmp0>=-90 && tmp0<=90 && tmp1!=tmp0) {
                        this.latLng.push({
                            name: '纬度' + tmp0 + ', ' + '经度' + tmp1,
                            detail: '经纬度来源：WGS84坐标系',
                            location:  [tmp1, tmp0]
                        })
                        this.latLng.push({
                            name: '纬度' + tmp0 + ', ' + '经度' + tmp1,
                            detail: '经纬度来源：百度地图',
                            location:  [tmp1, tmp0]
                        })
                        this.latLng.push({
                            name: '纬度' + tmp0 + ', ' + '经度' + tmp1,
                            detail: '经纬度来源：高德地图/谷歌地图',
                            location:  [tmp1, tmp0]
                        })
                    }
                }
            }

            if (this.keyword === null){this.keyword = ''}
            if (this.keyword === ''){
                this.targetResult = []
                this.poiResult = []
                this.clear();
                return
            }
            this.search();
        },
    },
  }
  </script>

  <style lang="scss" scoped>
  .createImgSeparateCtn{
    width: 159px;
    height: 41px;
    background: rgba(255,255,255,0.1);
    border-radius: 8px;
    margin-right: auto;
    margin-left: auto;
    margin-top: 20px;
    margin-bottom: 20px;
    line-height: 41px;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #FFFFFF;
    cursor:pointer;
  }
  .mapdiv{
      position: absolute;
      // width: calc(100% - 10px);
      // height: calc(100% - 10px);
      // left: 5px;
      // top: 5px;
      width: 100%;
      height: 100%;
      overflow: hidden;
  }
  .bak{
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: url('~@/assets/Laboratory/背景.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  // ::v-deep .searchBar,
  // ::v-deep .dfmAllDiv,
  // ::v-deep .searchList{
  //   left: 500px;
  // }
  // ::v-deep .dfmBtnDiv{
  //   left: 710px;
  // }

  .laboratoryLogo{
    position: relative;
    .mark{
      position: absolute;
      width: 100px;
      height: 100vh;
      left: 0;
      top: 0;
      // background: linear-gradient(270deg, rgba(0,0,0,0) 20%, rgba(0,0,0,0) 77%, rgba(0,0,0,0.25) 88%, #000000 100%);
      background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 40%, rgba(0, 0, 0, 0.5) 60%, #000000 100%);
    }
    .recordBtn{
      position: absolute;
      right: 30px;
      top: 90px;
      background: url('~@/assets/Laboratory/流量查看_默认.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 54px;
      height: 54px;
      cursor: pointer;
    }
    .recordBtn:hover{
      background: url('~@/assets/Laboratory/流量查看_hover.png');
    }
    .logoPanel{
      position: absolute;
      width: 440px;
      height: 54px;
      background: #2A2A2A;
      border-radius: 8px;
      top: 15px;
      left: 15px;
      .panelDoms{
        display: flex;
        align-items: center;
        height: 100%;
        .hoverNavi{
          cursor: pointer;
          background: url('~@/assets/Laboratory/导航按钮_黑底.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 44px;
          height: 44px;
          margin-left: 17px;
        }
        .hoverNavi:hover{
          background: url('~@/assets/Laboratory/导航按钮_黑底_hover.png');
        }
        .hoverLogoContent{
          position: fixed;
          top: 60px;
          left: 20px;
          width: 0px;
          height: 0px;
          overflow: hidden;
          z-index: 1000;
      }
      .hoverWhite{
      position: fixed;
      top: 76px;
      left: 20px;
      width: 0px;
      height: 0px;
      background: #000;
      box-shadow: 2px 2px 10px 2px rgba(255,255,255,0.2);
      border-radius: 16px;
      transition: 0.3s;
      overflow: hidden;
      z-index: 1000;
  }
  .hoverMainImg{
      position: absolute;
      top: 20px;
      left: 44px;
      width: 175px;
      height: 40px;
  }
  .hoverJiantou{
      position: absolute;
      width: 18px;
      height: 16px;
      top: 35px;
      left: 433px;
  }
  .hoverLine{
      position: absolute;
      top: 80px;
      left: 28px;
      width: 444px;
      height: 1px;
      border-top: 1px solid #CCCCCC;
  }
  .hoverLogo{
    position: absolute;
      top: 100px;
      left: 28px;
      width: 220px;
      height: 60px;
      background: #000;
      border-radius: 6px;
      }
  .hoverLogo:hover{
    background: rgba(0,0,0,0.7);
  }
  .hoverImg{
      position: absolute;
      top: 19px;
      left: 24px;
      width: 20px;
      height: 20px;
  }
  .hoverLogoText1{
      position: absolute;
      top: 17px;
      left: 66px;
      width: 85px;
      height: 24px;
      font-size: 20px;
      font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
      font-weight: normal;
      color: #fff;
      line-height: 24px;
  }
  .hoverLogoText2{
      position: absolute;
      top: 35px;
      left: 66px;
      width: 133px;
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: rgba(255,255,255,0.7);
      line-height: 17px;
      opacity: 0;
  }
        .dashedLine{
          width: 1px;
          height: 26px;
          border: 1px solid rgba(255,255,255,0.75);
          margin-left: 15px;
        }
        .logo{
          background: url('~@/assets/Laboratory/实验室logo_white.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 132px;
          height: 42px;
          margin-left: 25px;
          margin-top: 5px;
        }
        .introductionBtn{
          cursor: pointer;
          position: absolute;
          // top: 12px;
          right: 14px;
          width: 54px;
          height: 30px;
          background: rgba(255,255,255,0.15);
          border-radius: 6px;
          display: flex;
          justify-content: center;
          align-items: center;

          font-size: 14px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #EAEAEA;
          line-height: 20px;
        }
      }

      .moreTools{
        position: absolute;
        width: calc(100vw - 580px);
        height: 54px;
        background: #2A2A2A;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 445px;
        z-index: 1000;

        font-size: 14px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #CCCCCC;
        line-height: 20px;

        .closeImg{
          position: absolute;
          right: 11px;
          cursor: pointer;
        }
      }
      .closePanel{
        position: absolute;
        right: -25px;
        top: 0px;
        cursor: pointer;
        background: url('~@/assets/Laboratory/展开按钮_默认.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 20px;
        height: 54px;
      }
      .closePanel:hover{
        background: url('~@/assets/Laboratory/展开按钮_hover.png');
      }
    }
    .layersAndVectorsPanel{
      position: absolute;
      width: 440px;
      height: 100vh;
      background: #2A2A2A;
      top: 0px;
      left: 0px;
      z-index: 1;
      .tabs{
        width: 100%;
        height: 56px;
        display: flex;
        border-bottom: 1px solid rgba(255,255,255,0.25);

        .tab{
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 14px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #FFFFFF;
          line-height: 20px;
        }
        .lefttab{
          border-right: 1px solid rgba(255,255,255,0.25);
          border-top-left-radius: 8px;
        }
        .righttab{
          border-top-right-radius: 8px;
        }
        .active{
          background: rgba(0,102,204,0.15);
        }
      }

      .ps {
        // height: 885px;
        // height: 1782px;
        height: calc(100vh - 156px);
        position: unset;
        .ps__rail-y,
        .ps__rail-y.ps__thumb-y{
          right: 18px !important;
        }
      }
      .tabPanels{
        color: white;
        height: calc(100% - 56px);
        // 滚动条样式

        .layersPanel{
          position: relative;
          max-height: 100%;
          overflow-y: auto;
          // overflow-y: hidden;
          overflow-x: hidden;
          // >div:nth-child(1){
          .ant-checkbox-group{
            margin-left: 20px;
            // width: 100%;
            // width: calc(100% - 30px);
            width: calc(100% - 20px);
          }
        }
        // .layersPanel:hover{
        //   overflow-y: overlay;
        // }
        .layersLi{
          position: relative;
          display: flex;
          align-items: center;
          height: 54px;
          color: #FFFFFF;
          font-weight: 400;
          .thumbImg{
            width: 42px;
            height: 42px;
            border: 1px solid rgba(255,255,255,0.2);
            margin-left: 15px;
            margin-right: 15px;
            img{
              width: 42px;
              height: 42px;
              padding: 5px;
            }
          }
          .mkInfo{
            >div:nth-child(2){
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #979797;
              line-height: 17px;
            }
          }
          .juanlianBtn{
            cursor: pointer;
            position: absolute;
            right: 10px;
            background: url('~@/assets/Laboratory/卷帘对比_默认.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            width: 30px;
            height: 30px;
          }
          .juanlianBtn:hover{
            background: url('~@/assets/Laboratory/卷帘对比_hover.png');
          }
        }
        .vectorLi{
          .thumbImg{
            img{
              padding: 10px;
            }
          }
        }
      }
      .closePanel{
        position: absolute;
        top: calc(50% - 74px);
        right: -25px;
        cursor: pointer;
        background: url('~@/assets/Laboratory/收起按钮_默认.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 20px;
        height: 54px;
      }
      .closePanel:hover{
        background: url('~@/assets/Laboratory/收起按钮_hover.png');
      }
    }

    .closePanelImg{
      cursor: pointer;
      position: absolute;
      left: 15px;
      top: calc(50vh - 54px);
      width: 20px;
      height: 54px;
      background: url('~@/assets/Laboratory/展开按钮_默认.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .closePanelImg:hover{
      background: url('~@/assets/Laboratory/展开按钮_hover.png');
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 10000;
    .dialog {
      position: absolute;
      width: 1080px;
      height: 680px;
      border-radius: 16px;
      left: calc(50% - 540px);
      top: calc(50% - 340px);
      z-index: 10001;
      background: #2A2A2A;

      // overflow-y: auto;
      // overflow-x: hidden;
      .dialogImg {
        position: absolute;
        top: 0;
        right: -50px;
        cursor: pointer;
      }
      .introductionImg{
        width: 100%;
        // max-height: 100%;
        // overflow-y: auto;
      }
    }
  }
  .dialog .introduction{
    overflow-y: auto;
    overflow-x: hidden;
    // overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
    padding: 10px;
    // 滚动条样式
    .ps {
      height: 660px;
    }
  }
  // .dialog .introduction:hover{
  //   overflow-y: overlay;
  // }

  .shadow_tools_tip {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 10000;
    .dialog {
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      position: absolute;
      width: 768px;
      height: 460px;
      border-radius: 16px;
      left: calc(50% - 384px);
      top: calc(50% - 230px);
      z-index: 10001;
      background: #2A2A2A;
      .dialogImg {
        position: absolute;
        top: 0;
        right: -50px;
        cursor: pointer;
      }
      >div:nth-child(2){
        width: 36px;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 25px;
        margin: 50px 0;
      }
      >div:nth-child(3){
        width: 600px;
        height: 120px;
        font-size: 16px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 30px;
      }
      >div:nth-child(4){
        margin: 100px 0;
      }
    }
  }
  .shadow_tip {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 10000;
    .dialog {
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      position: absolute;
      width: 768px;
      height: 460px;
      border-radius: 16px;
      left: calc(50% - 384px);
      top: calc(50% - 230px);
      z-index: 10001;
      background: #2A2A2A;

      >div:nth-child(1){
        width: 36px;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 25px;
        margin: 50px 0;
      }
      >div:nth-child(2){
        width: 600px;
        height: 120px;
        font-size: 16px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 30px;
      }
      >div:nth-child(3){
        margin: 100px 0;
      }
    }
  }

  .tabsNavi{
    position: absolute;
    width: calc(100vw - 440px);
    height: 56px;
    background: #2A2A2A;
    top: 0;
    left: 440px;
  }
  .tabsNavi-s{
    position: absolute;
    width: 100vw;
    height: 56px;
    background: #2A2A2A;
    top: 0;
    left: 0px;
  }
.tabsNaviInput{
    position: absolute;
    top: 0;
    left: 25px;
    width: 262px;
    height: 42px;
    border-bottom: 1px solid #FFFFFF;
    opacity: 0.7;
}
.tabsNaviInput1{
    position: absolute;
    width: 250px;
    top: 15px;
    left:0px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 500;
    color: #fff;
    line-height: 20px;
    border:none;
    outline: none;
}
.tabsNaviSearch{
position: absolute;
top: 18px;
right: 5px;
cursor: pointer;
}
.tabsNaviChange{
    position: absolute;
    top: 17px;
    left: calc(50% - 175px);
    width:350px;
    height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #979797;
    line-height: 20px;
    cursor: pointer;
    text-align: right;
    padding-right: 20px;
}
.tabsNaviList{
    position: absolute;
    top:40px;
    right:-20px;
    width: auto;
    height:auto;
    box-shadow: 0px 0px 5px 0px rgba(255,255,255,0.2);
    border-radius: 8px;
}
.tabsNaviList1{
    background: #2A2A2A;
    width:auto;
    height: 60px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #979797;
    line-height: 20px;
    background: #2A2A2A;
    cursor: pointer;
    padding-top: 10px;
    padding-left: 40px;
    padding-right: 40px;
    text-align: left;
}
.tabsNaviList1:hover{
    background: grey;
    color: #3a3a3a;

}
.tabsNaviList11{
    background: #2A2A2A;
    width:auto;
    height: 60px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #979797;
    line-height: 20px;
    background: #2A2A2A;
    cursor: pointer;
    padding-top: 10px;
    padding-left: 40px;
    padding-right: 40px;
    text-align: left;
    border-radius: 8px 8px 0 0;
}
.tabsNaviList11:hover{
    background: grey;
    color: #3a3a3a;

}
.tabsNaviList12{
    background: #2A2A2A;
    width:auto;
    height: 60px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #979797;
    line-height: 20px;
    background: #2A2A2A;
    cursor: pointer;
    padding-top: 10px;
    padding-left: 40px;
    padding-right: 40px;
    text-align: left;
    border-radius: 0 0 8px 8px;
}
.tabsNaviList12:hover{
    background: grey;
    color: #3a3a3a;

}
.tabsNaviClose{
    position: absolute;
    top: 17px;
    right: 40px;
    width: 28px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #CCCCCC;
line-height: 20px;
cursor: pointer;
}
.tabPanelsSearch{
   position: relative;
   margin-top: 27px;
   margin-left: 19px;
    width: 400px;
    height: 44px;
    background: #3A3A3A;
    border-radius: 22px;
}
.tabPanelsBlock1{
    position: relative;
    margin-left: 4px;
    width: 431px;
    height: 52px;
    cursor: pointer;
}
.tabPanelsBlock1-s{
    position: relative;
    margin-left: 4px;
    width: 431px;
    height: 52px;
background: rgba(0,102,204,0.1);
    cursor: pointer;
}
.tabPanelsBlock1:hover{
background: rgba(0,102,204,0.1);
}
.tabBlock1Select{
    position: absolute;
    top: 19px;
    left: 13px;
}
.tabBlock1Text1{
    position: absolute;
    top: 5px;
    left: 96px;
    width:320px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #FFFFFF;
  line-height: 20px;
  white-space: nowrap;     /* 不换行 */
  overflow: hidden;        /* 隐藏溢出的内容 */
  text-overflow: ellipsis; /* 使用省略号表示溢出部分 */
}
.tabBlock1Text2{
    position: absolute;
    top: 32px;
    left: 115px;
    width: 40px;
height: 16px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #979797;
line-height: 17px;
}
.tabBlock1Text3{
  position: absolute;
  top: 40px;
  left: 96px;
  width: 300px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #979797;
line-height: 20px;
}
.tabBlock1Button1{
  position: absolute;
  top: 90px;
  left: 153px;
  width: 125px;
height: 32px;
background: #EAEAEA;
border-radius: 8px;
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height:32px;
text-align: center;
cursor: pointer;
}
.newGuideShadow{
  position: fixed;
  left: 440px;
  top: 0;
  width: calc(100vw - 440px);
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuide1Text1{
  position: absolute;
  top: 54px;
  left: 131px;
  width: 250px;
height: 30px;
font-size: 24px;
font-family: HanziPenSC-W5, HanziPenSC;
font-weight: normal;
color: #FFFFFF;
line-height: 30px;
}
.newGuide4Text1{
  position: absolute;
  top: 0px;
  right: 70px;
  width: 250px;
height: 30px;
font-size: 24px;
font-family: HanziPenSC-W5, HanziPenSC;
font-weight: normal;
color: #FFFFFF;
line-height: 30px;
}
.newGuide1Block{
  position: absolute;
  top: 99px;
  left: 30px;
  width: 400px;
height: 300px;
border-radius: 8px;
border: 2px solid #FFFFFF;
}
.newGuide4Block{
  position: absolute;
  top: 40px;
  right: 30px;
  width: 400px;
height: 300px;
border-radius: 8px;
border: 2px solid #FFFFFF;
}
.newGuideBlock1{
  position: absolute;
  top: 6px;
  left: 6px;
  width: 386px;
height: 286px;
border-radius: 3px;
border: 1px solid rgba(255, 255, 255, 0.5);
}
.newGuide1Text2{
  position: absolute;
  top: 19px;
  left: 28px;
  width: 330px;
height: 185px;
font-size: 21px;
font-family: HanziPenSC-W5, HanziPenSC;
font-weight: normal;
color: #FFFFFF;
line-height: 35px;
}
.newGuide1Button1{
position: absolute;
top: 233px;
left: 83px;
width: 100px;
height: 30px;
background: #FFFFFF;
border-radius: 8px;
font-size: 21px;
font-family: HanziPenSC-W5, HanziPenSC;
font-weight: normal;
color: #000;
line-height: 35px;
text-align: center;
cursor: pointer;
}
.newGuideShadow31{
  position: fixed;
  left: 0px;
  top: 0;
  width: 440px;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow32{
  position: fixed;
  left: 770px;
  top: 0px;
  width: calc(100vw - 770px);
  height: 85px;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow33{
  position: fixed;
  left: 440px;
  top:85px;
  width: calc(100vw - 440px);
  height: calc(100vh - 85px);
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow41{
  position: fixed;
  left: 0px;
 bottom:375px;
  width: 100vw;
  height: calc(100vh - 375px);
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow42{
  position: fixed;
  left: 0px;
  right: 150px;
 bottom:0px;
  width: calc(100vw - 150px);
  height: 375px;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow43{
  position: fixed;
  right: 0px;
 bottom:0px;
  width: 150px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.fenpingShadow{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent11{
    position: fixed;
    top: calc(50% - 160px);
    left: calc(50% - 400px);
    width: 800px;
    height: 320px;
    background: #FFFFFF;
    border-radius: 12px;
}
.shadowText11{
    position: absolute;
    top: 50px;
    left: calc(50% - 150px);
    width: 300px;
height: 60px;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 25px;
line-height: 30px;
text-align: center;
}
.shadowText22{
    position: absolute;
    top: 124px;
    left: 120px;
    width: 560px;
height: 50px;
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height: 25px;
text-align: center;
}
.shadowButton11{
    position: absolute;
    top:234px;
    left:261px;
    width: 169px;
height: 40px;
background: #0066CC;
border-radius: 6px;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.shadowButton22{
    position: absolute;
    top: 234px;
    left: calc(50% - 50px);
    width: 100px;
height: 40px;
background: #FFFFFF;
border-radius: 6px;
border: 1px solid #0066CC;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #0066CC;
line-height: 40px;
text-align: center;
cursor: pointer;
}

  /* 勾选框样式，有点乱 */
  ::v-deep .ant-checkbox-checked::after{
    background: url('~@/assets/Laboratory/单选框选中.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border: unset;
    transform: unset;
    visibility: unset;
    box-shadow: 1px 1px 2px 0px rgba(184,184,184,0.5), inset 0px 0px 2px 0px rgba(0,0,0,0.5);
  }
  ::v-deep .ant-checkbox-disabled{
    background: url('~@/assets/Laboratory/单选框选中.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  ::v-deep .ant-checkbox-checked .ant-checkbox-inner::after{
    opacity: unset;
    transform: unset;
    border: unset !important;
  }
  ::v-deep .ant-checkbox-inner::after{
    border: unset;
  }
  ::v-deep .ant-checkbox-checked .ant-checkbox-inner{
    background-color: unset;
    border: unset;
  }
  ::v-deep .ant-checkbox-inner{
    background-color: unset;
    background: url('~@/assets/Laboratory/单选框默认.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border: unset;
    transform: unset;
    visibility: unset;
    box-shadow: 1px 1px 2px 0px rgba(184,184,184,0.5), inset 0px 0px 2px 0px rgba(0,0,0,0.5);
  }


  ::v-deep .ant-select-selection{
      background: rgba(0,0,0,0.5);
      color: white;
  }
  ::v-deep .ant-select-arrow{
      color: white;
  }
  </style>
  <!-- 流量样式 -->
  <style scoped>
    .bar{
      position: relative;
      width: 100%;
      height: 76px;
      background-color: #fff;
  }
  .freeback{
      position: relative;
      width: 100%;
      height: 40px;
      background: #0066CC;
  }
  .freebackBlue{
      position: absolute;
      width: 1920px;
      height: 40px;
  }
  .freebackText{
      position: absolute;
      left:50%;
      transform:translate(-50%,0);
      width: 800px;
      height:40px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height:40px;
      text-align: center;
      z-index: 1;
  }
  .freebackClose{
      position: absolute;
      width: 14px;
      height: 14px;
      right: 50px;
      top: 13px;
      cursor: pointer;
  }
  .navi{
      position: relative;
      width: 100%;
      height: 40px;
      background: #F5F5F6;
  }
  .naviContent{
      position: absolute;
      width: 1920px;
      height: 40px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3A3A3A;
      line-height: 40px;
      padding-left: 120px;
  }
  .greyBasis{
      position: relative;
      width: 100%;
      height: auto;
      background-color: #fff;
      overflow: hidden;
  }
  .basisTitle{
      position: absolute;
      top: 43px;
      left: calc(50% - 201px);
      width: 402px;
      height: 42px;
      z-index: 1;
  }
  .basisText1{
      position: absolute;
      top: 53px;
      left: calc(50% - 400px);
      width:800px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3A3A3A;
      line-height: 22px;
      text-align: center;
      z-index: 2;
  }
  .greyContent{
      margin-top: 50px;
      margin-left: calc(50% - 640px);
      width: 1280px;
      height:auto;
      background: #F7F7F7;
      border-radius: 16px;
      padding-bottom: 20px;
      margin-bottom: 50px;
      overflow: hidden;
  }
  .keyManage{
      position: relative;
      margin-left: calc(50% - 560px);
      width: 1120px;
      height: 48px;
      /* background-color: pink; */
      margin-top: 75px;
      margin-bottom: 50px;
  }
  .greyList{
      position: relative;
      margin-left: calc(50% - 560px);
      margin-bottom: 10px;
      width: 1120px;
      height: 54px;
      background: #FFFFFF;
      border-radius: 8px;
      overflow: hidden;
  }
  .greyListBlock{
      position: relative;
      margin-top: 17px;
      margin-left: 222px;
      margin-bottom: 17px;
      width: 600px;
      height: 20px;
  }
  .greyList-s{
      position: relative;
      margin-left: calc(50% - 560px);
      margin-bottom: 80px;
      width: 1120px;
      height: 54px;
      background: #FFFFFF;
      border-radius: 8px;
  }
  .greyListText1{
      position: absolute;
      right: 749px;
      top: 17px;
      width:400px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3A3A3A;
  line-height: 20px;
  text-align: right;
  }
  .gretListLine{
      position: absolute;
      top: 14px;
      left: 400px;
      width: 2px;
      height: 26px;
      background-color:#979797 ;
      opacity: 0.5;
  }
  .greyListText{
      position: absolute;
      top: 17px;
      left: 430px;
      width: 483px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 20px;
  }
  .greyListText-s{
      position: relative;
      margin-top: 13px;
      margin-bottom: 20px;
      margin-left: 422px;
      width: 690px;
      height: 20px;
  }
  .greyListText-s1{
      position: relative;
      margin-bottom: 20px;
      margin-left: 422px;
      width: 690px;
      height: 20px;
  }
  .greyListText1-s{
      position: absolute;
      left: 8px;
      width: 280px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #B8B8B8;
      line-height: 20px;
  }
  .greyListLine{
      position: absolute;
      top: 10px;
      left: 0;
      width: 280px;
      height: 1px;
      background:  #B8B8B8;
  }
  .greyListText2-s{
      position: absolute;
      left: 330px;
      width: 150px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 20px;
  }
  .keyLine1{
      position: absolute;
      top: 24px;
      left: 0;
      width: 508px;
      height: 1px;
      border-bottom: 1px dashed #979797;
  }
  .keyLine2{
      position: absolute;
      top: 24px;
      right: 0;
      width: 508px;
      height: 1px;
      border-bottom: 1px dashed #979797;
  }
  .keyIcon1{
      position: absolute;
      top: 0;
      left: calc(50% - 40px);
      width: 80px;
      height: 48px;
  }
  .keyIcon2{
      position: absolute;
      top: 19px;
      right: 55px;
      cursor: pointer;
  }
  .keyIcon3{
      position: absolute;
      top: 19px;
      right: 100px;
      cursor: pointer;
  }
  .keyIcon_compare{
      position: absolute;
      top: 20px;
      right: 15px;
      cursor: pointer;
  }
  .keyIcon4{
  position: absolute;
  top: 13px;
  right: 23px;
  cursor: pointer;
  }
  .keyTitle{
      position: absolute;
      top: 13px;
      left: calc(50% - 60px);
      width: 120px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 22px;
  text-align: center;
  }
  .countTitle{
    margin-left: calc(50% - 400px);
    margin-top: 50px;
    margin-bottom: 25px;
    width: 800px;
    height: 20px;
    text-align: center;

    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 25px;
  }
  .countText1{
      margin-left: calc(50% - 400px);
      margin-bottom: 25px;
      width: 800px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #CCCCCC;
      line-height: 20px;
      text-align: center;
  }
  .countWhite{
      position: relative;
      /* margin-left: calc(50% - 500px); */
      /* margin-bottom: 80px; */
      width: 1000px;
      height: 520px;
  /* background: #FFFFFF; */
  border-radius: 8px;
  color: #FFFFFF;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  }
  .greyImg{
      position: absolute;
      top: 30px;
      left: 67px;
      width: 41px;
      height: 41px;
      background: #5b5b5b1b;
      border-radius: 50%;
      cursor: pointer;
  }
  .countIcon1{
      position: absolute;
      top: 41px;
      left: 79px;
      cursor: pointer;
  }
  .countIcon3{
      position: absolute;
      width: 20px;
      height: 20px;
      top: 5px;
      right: 5px;
      cursor: pointer;
  }
  .countIcon2{
      position: absolute;
      top: 41px;
      left: 250px;
      cursor: pointer;
  }
  .countText2{
      position: absolute;
      top: 38px;
      left: 271px;
      width: 90px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 20px;
      text-align: center;
  }
  .countCalendar{
      position: absolute;
      width: 476px;
      height: 224px;
      top: 103px;
      left: 68px;
  }
  .countCircle{
      position: relative;
      float: left;
      margin-left: 10px;
      margin-bottom: 11px;
      width: 44px;
      height: 44px;
      cursor: pointer;
  }
  .countCirclespe1{
      position: relative;
      float: left;
      margin-left: 108px;
      margin-bottom: 11px;
      width: 44px;
      height: 44px;
      cursor: pointer;
  }
  .countCirclespe2{
      position: relative;
      float: left;
      margin-left: 0px;
      margin-bottom: 11px;
      width: 44px;
      height: 44px;
      cursor: pointer;
  }
  .countCircle1{
      position: absolute;
      top: 0;
      left: 0;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: transparent;
  }
  .countCircle2{
      position: absolute;
      top: 4px;
      left: 4px;
      width: 36px;
      height: 36px;
      background-color: rgb(42 42 42);
      border-radius: 50%;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF ;
  }
  .calendarDialog{
      position: absolute;
      width: 400px;
      height: 150px;
      background: #FFFFFF;
      box-shadow: 1px 1px 5px 2px rgba(0,0,0,0.2);
      top: 75px;
      left: 79px;
      z-index: 1;
  }
  .calendarDialog{
      position: absolute;
      width: 400px;
      height: 150px;
      background: #FFFFFF;
      box-shadow: 1px 1px 5px 2px rgba(0,0,0,0.2);
      top: 75px;
      left: 79px;
      z-index: 1;
  }
  .calendarYear{
      position: absolute;
      width: 64px;
      height: 30px;
      background: #fff;
      top: 15px;
      left: 100px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #3A3A3A;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
  }
  .calendarYear-s{
      position: absolute;
      width: 64px;
      height: 30px;
      background: #fff;
      top: 15px;
      left: 100px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #49C2FF;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
  }
  .calendarYear:hover{
      background: #F7F7F7;
  }
  .calendarMonth{
      position: absolute;
      width: 330px;
      height: 64px;
      top: 65px;
      left: 43px;
  }
  .calendarMonth1{
      float: left;
      background: #fff;
      margin-right: 15px;
      margin-bottom: 12px;
      width: 40px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3A3A3A;
      line-height: 20px;
      text-align: center;
      cursor: pointer;
  }
  .calendarMonth1-s{
      float: left;
      background: #fff;
      margin-right: 15px;
      margin-bottom: 12px;
      width: 40px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #49C2FF;
      line-height: 20px;
      text-align: center;
      cursor: pointer;
  }
  .calendarMonth1:hover{
      background: #F7F7F7;

  }
  .totalStatistics{
      position: absolute;
      top: 342px;
      left: 79px;
      width: 480px;
      height: 42px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 22px;
  }
  .calendarTip{
    position: absolute;
   bottom: 60px;
    left: 79px;
    width: 480px;
    height:auto;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 22px;
}
  .mkStatistics{
      top: 40px;
      left: 630px;
      position: absolute;
      height: 420px;
      width: 380px;
      overflow-y: auto;
      overflow-x: hidden;
  }
  .mkNum{
      position: relative;
      width: 500px;
      height: 20px;
      margin-bottom: 20px;
  }
  .mkNumName{
      position: absolute;
      left: 0;
      top: 0;
      width: 300px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      /* color: #3A3A3A; */
      color: #FFFFFF;
      line-height: 20px;
  }
  .mkNumCount{
      position: absolute;
      left: 300px;
      width: 100px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      /* color: #777777; */
      color: #979797;
      line-height: 20px;
  }
  .greyButton{
      margin-left: calc(50% - 75px);
      width: 150px;
      height: 40px;
      background: #1E81EB;
      border-radius: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      margin-bottom: 125px;
  }
  .shadow {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10000;
  }
  .shadowContent1{
      position: fixed;
      top: calc(50% - 200px);
      left: calc(50% - 400px);
      width: 800px;
      height: 400px;
      background: #FFFFFF;
      border-radius: 12px;
  }
  .shadowClose{
  position: absolute;
  width: 40px;
  height: 40px;
  top: 0px;
  right: -55px;
  cursor: pointer;
  }
  .shadowtext1{
      position: absolute;
      top: 50px;
      left: calc(50% - 60px);
      width: 120px;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 25px;
  text-align: center;
  }
  .shadowText2{
      position: absolute;
      top: 108px;
      left: 74px;
      width: 660px;
  height: 150px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 30px;
  }
  .shadowButton{
      position: absolute;
      top: 307px;
      left: calc(50% - 75px);
      width: 150px;
      height: 40px;
      background: #CCCCCC;
      border-radius: 6px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 40px;
      text-align: center;
  }
  .shadowButton1{
      position: absolute;
      top: 307px;
      left: calc(50% - 75px);
      width: 150px;
      height: 40px;
      background: #0066CC;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 40px;
      text-align: center;
  }

  ::v-deep .mapDialog{
      overflow-y: unset;
      z-index: 1001;
  }
  ::v-deep .theme--light.v-card{
      background: rgba(238,238,238);
  }
    </style>

  <style lang="scss" scoped>

  // 滚动条宽度
  div::-webkit-scrollbar{
    width: 10px;
  }
  // 滚动条轨道
  div::-webkit-scrollbar-track{
    background: rgb(239, 239, 239,0);
    border-radius: 2px;
  }
  // 小滑块
  div::-webkit-scrollbar-thumb{
    background: rgba(76, 76, 76, 0.8);
    border-radius: 10px;
  }
  div::-webkit-scrollbar-thumb:hover{
    background: rgba(76, 76, 76, 1);
  }

  ::v-deep .ps__thumb-y{
    cursor: pointer;
  }
  ::v-deep .ps .ps__rail-x:hover,
  ::v-deep .ps .ps__rail-y:hover,
  ::v-deep .ps .ps__rail-x:focus,
  ::v-deep .ps .ps__rail-y:focus,
  ::v-deep .ps .ps__rail-x.ps--clicking,
  ::v-deep .ps .ps__rail-y.ps--clicking {
    background-color: unset;
    opacity: 0.9;
  }
  </style>

  <style lang="scss" scoped>
  .fast_btn {
    // width: 128px;
    margin: 0 auto;
    padding-left: 0px;
    .content_btn {
      width: 128px;
      height: 44px;
      margin: 0 auto;
      background: linear-gradient(180deg, #229bff 0%, #0071e3 100%);
      border-radius: 27px;
      border: 1px solid transparent;/*消除悬停时一像素错位调动的问题*/
      outline: none;
      color: #ffffff;
      text-align: center;

      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 20px;
    }
    .content_btn_border {
      margin-left: 20px;
      width: 128px;
      height: 44px;
      border-radius: 27px;
      border: 1px solid #ffffff;
      text-align: center;
      color: #ffffff;
      background: rgba(0, 0, 0, 0);//去掉浅蓝色背景的干扰


      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 20px;
    }
    }
  </style>


<!-- POI -->
<style lang="scss" scoped>
    .dfmBtn{
        position: absolute;
        top: 18px;
        left: 210px;
        color: white;
    }
    ::v-deep .dfmBtnDiv{
        cursor: pointer;
        position: absolute;
        // top: 25px;
        top: 13px;
        left: 235px;
        // border: #a4a4a4 1px solid;
        border-radius: 4px;
        width: 30px;
        height: 30px;
        background-color: rgba(42 42 42);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    ::v-deep .dfmAllDiv{
        position:absolute;
        display:flex;
        align-items:center;
        width:500px;
        z-index:999;
        // top:25px;
        top:13px;
        left: 25px;
    }
    ::v-deep .sjzBtnDiv{
        cursor: pointer;
        margin-left: 10px;
        // border: #a4a4a4 1px solid;
        border-radius: 4px;
        width: 30px;
        height: 30px;
        background-color: rgba(42 42 42);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    ::v-deep .searchBar{
        position: absolute;
        width: 200px;
        // top: 25px;
        top: 13px;
        left: 25px;
        background: #2A2A2A;
    }
    .searchList{
        position: absolute;
        min-width: 424px;
        top: 65px;
        left: -10px;
        box-shadow: 0px 0px 5px 0px rgba(255,255,255,0.2);
        border-radius: 8px;
    }
    // ::v-deep .ant-list-items{
    .searchListItem{
        background: #2A2A2A;
        div{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 38px;
            color:white;
            a{
                font-size:14px;
                color:white;
            }
            span{
                font-size:12px;
                margin-left:30px;
                color:white;
            }
        }
    }
    ::v-deep .ant-spin-container{
        background: unset;
    }
    ::v-deep .ant-list-item{
        border-bottom: unset !important;
    }
    ::v-deep .anticon,
    ::v-deep .ant-input-suffix,
    ::v-deep .ant-input-suffix:hover{
        color:rgb(185, 185, 185);
    }
    ::v-deep .ant-input-clear-icon:hover{
        color:rgb(255, 255, 255);
    }
    ::v-deep .ant-input{
        background: rgba(42 42 42);
        color:rgb(185, 185, 185);
    }
    ::v-deep .ant-input-clear-icon{
        color:rgb(185, 185, 185);
    }
    ::v-deep ul{
        padding-left:unset;
    }
    .homeStyle{
        left: 524px;
    }
    .homeBtnStyle{
        left: 730px;
    }
    .homeBtnTenStyle{
        left: 1030px;
    }

    .fakeMaskLock{
      background: black;
      position: absolute;
      top: calc(50% - 23px);
      left: calc(50% - 23px);
      transform: translate(2px, 0);
      z-index: 2;
      border-radius: 50%;

      img{
        width: 46px;
        height: 46px;
      }
    }
    .fakeMask{
      .panel{
        position: absolute;
        width: calc(100% - 240px);
        height: calc(100% - 250px);
        background: rgba(255,255,255,0.15);
        border-radius: 16px;
        overflow-y: auto;
        transform: translate(123px, 122px);
        z-index: 1;
        .divider{
          display: flex;
          align-items: center;
          justify-content: center;
          color: #979797;
          font-size: 14px;
        }
      }
    }
    ::v-deep .theme--light.v-label{
      color:#ffffff;
      font-size: 14px;
    }
    ::v-deep .theme--light.v-icon{
      color:#8AB6F9;
    }
    ::v-deep .v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate) .v-icon{
      color:#777777;
    }
    ::v-deep .v-input--is-disabled .theme--light.v-label{
      color:#777777;
      font-size: 14px;
    }
    ::v-deep .v-input--radio-group.v-input--radio-group--row .v-radio{
      margin-top: 10px;
    }
    ::v-deep .theme--light.v-divider{
      border-color: rgb(255 251 251 / 12%);
    }
</style>
